import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  References31yy1vpluik8j as References,
  Group209swmzf2sz2h as Group,
  AdminViewOnlyyhkyako4fc99 as AdminViewOnly,
  AdminTableColumns127mx0x3shj3w as AdminTableColumns,
  NaturalSort21fbc8xpuy7g0 as NaturalSort,
  Description1f0zycfwk0zld as Description,
  Denormalized13y861o5nekmb as Denormalized,
  Index2tzg8vllut89f as Index,
  Multilinevduzy7shc6h7 as Multiline,
  IndexSetppgakdbfpe00 as IndexSet,
  AdminTitleFields1r7jr8w0z0gjc as AdminTitleFields,
  IndexUniqueness_Unique_getInstance3k1wv494ui8l1 as IndexUniqueness_Unique_getInstance,
} from '../../../../service-abstractions-data-shared/com/lightningkite/services/data/Annotations.mjs';
import {
  UuidSerializer_getInstance1ib26ji9vwcd4 as UuidSerializer_getInstance,
  InstantSerializer_getInstance1n2pd669tdsta as InstantSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  compareTo1g8l26b65emtd as compareTo,
  TypedIdexo9ecsepo30 as TypedId,
  HasId24qpfucecockd as HasId,
} from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/HasId.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import {
  $serializer_getInstance36a6xm1fkegaj as $serializer_getInstance,
  ContactInfo1q5ur6ox19zr5 as ContactInfo,
  $serializer_getInstance1m3cbcq74wr1 as $serializer_getInstance_0,
  $serializer_getInstancegx2p6odi22tj as $serializer_getInstance_1,
  LocalDateRangefowoyqa24icz as LocalDateRange,
  Companion_getInstancec4abf6gzvhv2 as Companion_getInstance_0,
  Companion_getInstance18374pr9rm3ox as Companion_getInstance_1,
  $serializer_getInstanceva225auct2k8 as $serializer_getInstance_2,
  $serializer_getInstance2ga0n7x7no2vd as $serializer_getInstance_3,
  Companion_getInstance2n667ht97uzau as Companion_getInstance_2,
} from './types.mjs';
import {
  $serializer_getInstancez3kimx5dzjz3 as $serializer_getInstance_4,
  $serializer_getInstancez3cztbuzvhxy as $serializer_getInstance_5,
} from './money.mjs';
import { $serializer_getInstance1d82sdgf1kakj as $serializer_getInstance_6 } from './esignature.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance,
  IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { System_instance34rnn1q53nv02 as System_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/Clock.mjs';
import { Companion_getInstance13ujfby7pfhe7 as Companion_getInstance_3 } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import { todayIn1xeyw1nmvf0b4 as todayIn } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { periodUntil3upuuey2spoqs as periodUntil } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { DeferToContextualServerFileSerializer_getInstancebet21aefs4ur as DeferToContextualServerFileSerializer_getInstance } from '../../../../service-abstractions-files-client/com/lightningkite/services/files/DirectServerFileSerializer.mjs';
import {
  ServerFile2veqsg2df5jtr as ServerFile,
  ServerFile__toString_impl_4rulpa28j1bs1w6h1u6 as ServerFile__toString_impl_4rulpa,
  ServerFile__hashCode_impl_qj0ii51v31c23ib9tv8 as ServerFile__hashCode_impl_qj0ii5,
} from '../../../../service-abstractions-files-client/com/lightningkite/services/files/ServerFile.mjs';
import {
  $serializer_getInstance38surg0wl5xyc as $serializer_getInstance_7,
  ID3lnbkn76l7dgd as ID,
  ID__toString_impl_y5caka1p73pxlcdvne as ID__toString_impl_y5caka,
  ID__hashCode_impl_f4lulz1p7uxb6gqsw7j as ID__hashCode_impl_f4lulz,
} from './careRates.mjs';
import {
  ScheduledAttendance2v6gob50ik295 as ScheduledAttendance,
  $serializer_getInstance3tvk07wc79lhi as $serializer_getInstance_8,
} from './attendance.mjs';
import {
  LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { get_entries2ar453qbk297a as get_entries } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DayOfWeek.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
  emptyList1g2z5xcrvp2zy as emptyList,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { toSet2orjxp16sotqu as toSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { LocalDateSerializer_getInstance3qg2c8779i3ej as LocalDateSerializer_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateSerializers.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  toShortId2um7whkmaulbx as toShortId,
  _ShortId___get_asString__impl__omz5t82x1ggxl12av4g as _ShortId___get_asString__impl__omz5t8,
} from './humanId.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { trim11nh7r46at6sx as trim } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { equals2v6cggk171b6e as equals_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import {
  EmailAddress1cvm8sbtoer9i as EmailAddress,
  EmailAddressSerializer_getInstancezn5b5405tqyz as EmailAddressSerializer_getInstance,
  PhoneNumber16oapr4wkp1a5 as PhoneNumber,
  PhoneNumberSerializer_getInstanceq35z0l42la4e as PhoneNumberSerializer_getInstance,
  EmailAddress__hashCode_impl_wizg9y14xq3olyjcev0 as EmailAddress__hashCode_impl_wizg9y,
  PhoneNumber__hashCode_impl_t98twlqkqzqu7p5mbp as PhoneNumber__hashCode_impl_t98twl,
} from '../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import {
  Cents1lsbs5l1tlgw as Cents,
  $serializer_getInstance33z4kgxgrgb0n as $serializer_getInstance_9,
  Cents__hashCode_impl_slsn8n2ym5pwri0ohtt as Cents__hashCode_impl_slsn8n,
  Companion_instance1c40ds0jrup2e as Companion_instance_0,
} from '../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _ID___init__impl__k1lb7e(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5($this) {
  return $this;
}
function ID__toString_impl_y5caka_0($this) {
  return _ID___get_raw__impl__92g6u5($this).toString();
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_10();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_1;
function Companion_getInstance_4() {
  return Companion_instance_1;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.Employer.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(Employer())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_njir29_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_njir29_k$(encoder, value instanceof ID_0() ? value.raw_1 : THROW_CCE());
      }
      deserialize_uef49e_k$(decoder) {
        return _ID___init__impl__k1lb7e(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_0())(this.deserialize_uef49e_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_10() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function ID__hashCode_impl_f4lulz_0($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p($this, other) {
  if (!(other instanceof ID_0()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_0())(other instanceof ID_0() ? other.raw_1 : THROW_CCE()));
}
var IDClass;
function ID_0() {
  if (IDClass === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_0(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_0(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_10});
    IDClass = $;
  }
  return IDClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_11();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_2;
function Companion_getInstance_5() {
  return Companion_instance_2;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.Employer', this, 10);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('name', false);
        tmp0_serialDesc.addElement_5pzumi_k$('contact', true);
        tmp0_serialDesc.addElement_5pzumi_k$('billingAddress', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Group())('billing'));
        tmp0_serialDesc.addElement_5pzumi_k$('billingContactName', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Group())('billing'));
        tmp0_serialDesc.addElement_5pzumi_k$('sync', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (AdminViewOnly())());
        tmp0_serialDesc.addElement_5pzumi_k$('balance', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (AdminViewOnly())());
        tmp0_serialDesc.addElement_5pzumi_k$('signingInfo', true);
        tmp0_serialDesc.addElement_5pzumi_k$('signedDocument', true);
        tmp0_serialDesc.addElement_5pzumi_k$('active', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['name', 'contact.name', 'contact.email', 'contact.phone']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['~name']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_8i3bz8_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e(Companion_getInstance().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_10(), new (ID_0())(value._id_1));
        }
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.name_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !value.contact_1.equals(new (ContactInfo())())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance(), value.contact_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.billingAddress_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, $serializer_getInstance_0(), value.billingAddress_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.billingContactName_1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 4, value.billingContactName_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.sync_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, $serializer_getInstance_4(), value.sync_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.balance_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 6, $serializer_getInstance_5(), value.balance_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 7) ? true : !(value.signingInfo_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 7, $serializer_getInstance_6(), value.signingInfo_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 8) ? true : !(value.signedDocument_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 8, $serializer_getInstance_17(), value.signedDocument_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 9) ? true : !(value.active_1 === true)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 9, value.active_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_8i3bz8_k$(encoder, value instanceof Employer() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = false;
        var tmp14_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp14_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_10();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_0())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp14_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, $serializer_getInstance_0(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp14_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, $serializer_getInstance_4(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, $serializer_getInstance_5(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 7, $serializer_getInstance_6(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 8, $serializer_getInstance_17(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp14_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp14_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance_10();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (ID_0())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp14_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, $serializer_getInstance_0(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp14_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, $serializer_getInstance_4(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, $serializer_getInstance_5(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 7, $serializer_getInstance_6(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 8, $serializer_getInstance_17(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp14_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp14_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Employer().new_org_thecommunitygroupinc_cares_Employer_gl0jd5_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_10(), StringSerializer_getInstance(), $serializer_getInstance(), get_nullable($serializer_getInstance_0()), StringSerializer_getInstance(), get_nullable($serializer_getInstance_4()), get_nullable($serializer_getInstance_5()), get_nullable($serializer_getInstance_6()), get_nullable($serializer_getInstance_17()), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_11() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var EmployerClass;
function Employer() {
  if (EmployerClass === VOID) {
    class $ {
      constructor(_id, name, contact, billingAddress, billingContactName, sync, balance, signingInfo, signedDocument, active) {
        _id = _id === VOID ? _ID___init__impl__k1lb7e(Companion_getInstance().random_fimq0t_k$()) : _id;
        contact = contact === VOID ? new (ContactInfo())() : contact;
        billingAddress = billingAddress === VOID ? null : billingAddress;
        billingContactName = billingContactName === VOID ? '' : billingContactName;
        sync = sync === VOID ? null : sync;
        balance = balance === VOID ? null : balance;
        signingInfo = signingInfo === VOID ? null : signingInfo;
        signedDocument = signedDocument === VOID ? null : signedDocument;
        active = active === VOID ? true : active;
        this._id_1 = _id;
        this.name_1 = name;
        this.contact_1 = contact;
        this.billingAddress_1 = billingAddress;
        this.billingContactName_1 = billingContactName;
        this.sync_1 = sync;
        this.balance_1 = balance;
        this.signingInfo_1 = signingInfo;
        this.signedDocument_1 = signedDocument;
        this.active_1 = active;
      }
      get__id_py95t1_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_0())(this.get__id_py95t1_k$());
      }
      copy_3aljjb_k$(_id, name, contact, billingAddress, billingContactName, sync, balance, signingInfo, signedDocument, active) {
        return new (Employer())(_id, name, contact, billingAddress, billingContactName, sync, balance, signingInfo, signedDocument, active);
      }
      copy$default_g0qldq_k$(_id, name, contact, billingAddress, billingContactName, sync, balance, signingInfo, signedDocument, active, $super) {
        _id = _id === VOID ? this._id_1 : _id;
        name = name === VOID ? this.name_1 : name;
        contact = contact === VOID ? this.contact_1 : contact;
        billingAddress = billingAddress === VOID ? this.billingAddress_1 : billingAddress;
        billingContactName = billingContactName === VOID ? this.billingContactName_1 : billingContactName;
        sync = sync === VOID ? this.sync_1 : sync;
        balance = balance === VOID ? this.balance_1 : balance;
        signingInfo = signingInfo === VOID ? this.signingInfo_1 : signingInfo;
        signedDocument = signedDocument === VOID ? this.signedDocument_1 : signedDocument;
        active = active === VOID ? this.active_1 : active;
        return $super === VOID ? this.copy_3aljjb_k$(_id, name, contact, billingAddress, billingContactName, sync, balance, signingInfo, signedDocument, active) : $super.copy_3aljjb_k$.call(this, new (ID_0())(_id), name, contact, billingAddress, billingContactName, sync, balance, signingInfo, signedDocument, active);
      }
      toString() {
        return 'Employer(_id=' + ID__toString_impl_y5caka_0(this._id_1) + ', name=' + this.name_1 + ', contact=' + this.contact_1.toString() + ', billingAddress=' + toString_0(this.billingAddress_1) + ', billingContactName=' + this.billingContactName_1 + ', sync=' + toString_0(this.sync_1) + ', balance=' + toString_0(this.balance_1) + ', signingInfo=' + toString_0(this.signingInfo_1) + ', signedDocument=' + toString_0(this.signedDocument_1) + ', active=' + this.active_1 + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_0(this._id_1);
        result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
        result = imul(result, 31) + this.contact_1.hashCode() | 0;
        result = imul(result, 31) + (this.billingAddress_1 == null ? 0 : this.billingAddress_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.billingContactName_1) | 0;
        result = imul(result, 31) + (this.sync_1 == null ? 0 : this.sync_1.hashCode()) | 0;
        result = imul(result, 31) + (this.balance_1 == null ? 0 : this.balance_1.hashCode()) | 0;
        result = imul(result, 31) + (this.signingInfo_1 == null ? 0 : this.signingInfo_1.hashCode()) | 0;
        result = imul(result, 31) + (this.signedDocument_1 == null ? 0 : this.signedDocument_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.active_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Employer()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!this.contact_1.equals(other.contact_1))
          return false;
        if (!equals(this.billingAddress_1, other.billingAddress_1))
          return false;
        if (!(this.billingContactName_1 === other.billingContactName_1))
          return false;
        if (!equals(this.sync_1, other.sync_1))
          return false;
        if (!equals(this.balance_1, other.balance_1))
          return false;
        if (!equals(this.signingInfo_1, other.signingInfo_1))
          return false;
        if (!equals(this.signedDocument_1, other.signedDocument_1))
          return false;
        if (!(this.active_1 === other.active_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_Employer_gl0jd5_k$(seen0, _id, name, contact, billingAddress, billingContactName, sync, balance, signingInfo, signedDocument, active, serializationConstructorMarker) {
        if (!(2 === (2 & seen0))) {
          throwMissingFieldException(seen0, 2, $serializer_getInstance_11().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e(Companion_getInstance().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.name_1 = name;
        if (0 === (seen0 & 4))
          $this.contact_1 = new (ContactInfo())();
        else
          $this.contact_1 = contact;
        if (0 === (seen0 & 8))
          $this.billingAddress_1 = null;
        else
          $this.billingAddress_1 = billingAddress;
        if (0 === (seen0 & 16))
          $this.billingContactName_1 = '';
        else
          $this.billingContactName_1 = billingContactName;
        if (0 === (seen0 & 32))
          $this.sync_1 = null;
        else
          $this.sync_1 = sync;
        if (0 === (seen0 & 64))
          $this.balance_1 = null;
        else
          $this.balance_1 = balance;
        if (0 === (seen0 & 128))
          $this.signingInfo_1 = null;
        else
          $this.signingInfo_1 = signingInfo;
        if (0 === (seen0 & 256))
          $this.signedDocument_1 = null;
        else
          $this.signedDocument_1 = signedDocument;
        if (0 === (seen0 & 512))
          $this.active_1 = true;
        else
          $this.active_1 = active;
        return $this;
      }
    }
    initMetadataForClass($, 'Employer', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_11});
    EmployerClass = $;
  }
  return EmployerClass;
}
function _ID___init__impl__k1lb7e_0(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_0($this) {
  return $this;
}
function ID__toString_impl_y5caka_1($this) {
  return _ID___get_raw__impl__92g6u5_0($this).toString();
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_12();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_3;
function Companion_getInstance_6() {
  return Companion_instance_3;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.Grant.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(Grant())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_u0plrk_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_0(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_u0plrk_k$(encoder, value instanceof ID_1() ? value.raw_1 : THROW_CCE());
      }
      deserialize_vubqt3_k$(decoder) {
        return _ID___init__impl__k1lb7e_0(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_1())(this.deserialize_vubqt3_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_12() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
function ID__hashCode_impl_f4lulz_1($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_0($this, other) {
  if (!(other instanceof ID_1()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_0($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_1())(other instanceof ID_1() ? other.raw_1 : THROW_CCE()));
}
var IDClass_0;
function ID_1() {
  if (IDClass_0 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_0(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_1(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_1(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_0(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_0(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_12});
    IDClass_0 = $;
  }
  return IDClass_0;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_13();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_4;
function Companion_getInstance_7() {
  return Companion_instance_4;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.Grant', this, 6);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('name', false);
        tmp0_serialDesc.addElement_5pzumi_k$('funder', true);
        tmp0_serialDesc.addElement_5pzumi_k$('activeRange', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('The award period. An open-ended end date means it runs until superseded.'));
        tmp0_serialDesc.addElement_5pzumi_k$('sync', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (AdminViewOnly())());
        tmp0_serialDesc.addElement_5pzumi_k$('balance', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (AdminViewOnly())());
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['name', 'funder', 'activeRange.start', 'activeRange.endInclusive']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['~name']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_trf8ej_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_0(Companion_getInstance().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_12(), new (ID_1())(value._id_1));
        }
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.name_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.funder_1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.funder_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !value.activeRange_1.equals(new (LocalDateRange())(todayIn(System_instance, Companion_getInstance_3().currentSystemDefault_9rduv_k$())))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, $serializer_getInstance_1(), value.activeRange_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.sync_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, $serializer_getInstance_4(), value.sync_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.balance_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, $serializer_getInstance_5(), value.balance_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_trf8ej_k$(encoder, value instanceof Grant() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp10_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_12();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_1())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp10_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp10_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, $serializer_getInstance_1(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp10_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, $serializer_getInstance_4(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp10_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, $serializer_getInstance_5(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance_12();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (ID_1())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp10_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp10_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, $serializer_getInstance_1(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp10_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, $serializer_getInstance_4(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp10_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, $serializer_getInstance_5(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp10_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Grant().new_org_thecommunitygroupinc_cares_Grant_mwr8m1_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_12(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_1(), get_nullable($serializer_getInstance_4()), get_nullable($serializer_getInstance_5())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_13() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var GrantClass;
function Grant() {
  if (GrantClass === VOID) {
    class $ {
      constructor(_id, name, funder, activeRange, sync, balance) {
        _id = _id === VOID ? _ID___init__impl__k1lb7e_0(Companion_getInstance().random_fimq0t_k$()) : _id;
        funder = funder === VOID ? '' : funder;
        activeRange = activeRange === VOID ? new (LocalDateRange())(todayIn(System_instance, Companion_getInstance_3().currentSystemDefault_9rduv_k$())) : activeRange;
        sync = sync === VOID ? null : sync;
        balance = balance === VOID ? null : balance;
        this._id_1 = _id;
        this.name_1 = name;
        this.funder_1 = funder;
        this.activeRange_1 = activeRange;
        this.sync_1 = sync;
        this.balance_1 = balance;
      }
      get__id_kiodm_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_1())(this.get__id_kiodm_k$());
      }
      copy_p4xfw4_k$(_id, name, funder, activeRange, sync, balance) {
        return new (Grant())(_id, name, funder, activeRange, sync, balance);
      }
      copy$default_l6uaby_k$(_id, name, funder, activeRange, sync, balance, $super) {
        _id = _id === VOID ? this._id_1 : _id;
        name = name === VOID ? this.name_1 : name;
        funder = funder === VOID ? this.funder_1 : funder;
        activeRange = activeRange === VOID ? this.activeRange_1 : activeRange;
        sync = sync === VOID ? this.sync_1 : sync;
        balance = balance === VOID ? this.balance_1 : balance;
        return $super === VOID ? this.copy_p4xfw4_k$(_id, name, funder, activeRange, sync, balance) : $super.copy_p4xfw4_k$.call(this, new (ID_1())(_id), name, funder, activeRange, sync, balance);
      }
      toString() {
        return 'Grant(_id=' + ID__toString_impl_y5caka_1(this._id_1) + ', name=' + this.name_1 + ', funder=' + this.funder_1 + ', activeRange=' + this.activeRange_1.toString() + ', sync=' + toString_0(this.sync_1) + ', balance=' + toString_0(this.balance_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_1(this._id_1);
        result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.funder_1) | 0;
        result = imul(result, 31) + this.activeRange_1.hashCode() | 0;
        result = imul(result, 31) + (this.sync_1 == null ? 0 : this.sync_1.hashCode()) | 0;
        result = imul(result, 31) + (this.balance_1 == null ? 0 : this.balance_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Grant()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!(this.funder_1 === other.funder_1))
          return false;
        if (!this.activeRange_1.equals(other.activeRange_1))
          return false;
        if (!equals(this.sync_1, other.sync_1))
          return false;
        if (!equals(this.balance_1, other.balance_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_Grant_mwr8m1_k$(seen0, _id, name, funder, activeRange, sync, balance, serializationConstructorMarker) {
        if (!(2 === (2 & seen0))) {
          throwMissingFieldException(seen0, 2, $serializer_getInstance_13().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_0(Companion_getInstance().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.name_1 = name;
        if (0 === (seen0 & 4))
          $this.funder_1 = '';
        else
          $this.funder_1 = funder;
        if (0 === (seen0 & 8))
          $this.activeRange_1 = new (LocalDateRange())(todayIn(System_instance, Companion_getInstance_3().currentSystemDefault_9rduv_k$()));
        else
          $this.activeRange_1 = activeRange;
        if (0 === (seen0 & 16))
          $this.sync_1 = null;
        else
          $this.sync_1 = sync;
        if (0 === (seen0 & 32))
          $this.balance_1 = null;
        else
          $this.balance_1 = balance;
        return $this;
      }
    }
    initMetadataForClass($, 'Grant', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_13});
    GrantClass = $;
  }
  return GrantClass;
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  AgeGroup_Infant_instance = new (AgeGroup())('Infant', 0, 'Infant', 0);
  AgeGroup_Toddler_instance = new (AgeGroup())('Toddler', 1, 'Toddler', 15);
  AgeGroup_Preschool_instance = new (AgeGroup())('Preschool', 2, 'Preschool', 33);
  AgeGroup_SchoolAge_instance = new (AgeGroup())('SchoolAge', 3, 'School Age', 60);
  if (Companion_instance_5 === VOID) {
    Companion_instance;
    new (Companion_3())();
  }
}
var AgeGroup_Infant_instance;
var AgeGroup_Toddler_instance;
var AgeGroup_Preschool_instance;
var AgeGroup_SchoolAge_instance;
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      of_1hvtr1_k$(birthDate, on) {
        // Inline function 'kotlin.let' call
        var it = periodUntil(birthDate, on);
        var months = imul(it.get_years_j1r3xp_k$(), 12) + it.get_months_gqmrjw_k$() | 0;
        // Inline function 'kotlin.require' call
        if (!(months >= 0)) {
          var message = 'Born ' + birthDate.toString() + ', so not yet born on ' + on.toString() + '.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        var tmp0 = get_entries_0();
        var tmp$ret$4;
        $l$block: {
          // Inline function 'kotlin.collections.last' call
          var iterator = tmp0.listIterator_70e65o_k$(tmp0.get_size_woubt6_k$());
          while (iterator.hasPrevious_qh0629_k$()) {
            var element = iterator.previous_l2dfd5_k$();
            if (months >= element.fromMonths_1) {
              tmp$ret$4 = element;
              break $l$block;
            }
          }
          throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('List contains no element matching the predicate.');
        }
        return tmp$ret$4;
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_5;
function Companion_getInstance_8() {
  return Companion_instance_5;
}
function values() {
  static_init();
  return [AgeGroup_Infant_getInstance(), AgeGroup_Toddler_getInstance(), AgeGroup_Preschool_getInstance(), AgeGroup_SchoolAge_getInstance()];
}
function get_entries_0() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var $ENTRIES;
var AgeGroupClass;
function AgeGroup() {
  if (AgeGroupClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName, fromMonths) {
        super(name, ordinal);
        this.displayName_1 = displayName;
        this.fromMonths_1 = fromMonths;
      }
    }
    initMetadataForClass($, 'AgeGroup');
    AgeGroupClass = $;
  }
  return AgeGroupClass;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function CareLocationType$Companion$_anonymous__l8avg1() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.CareLocationType', values_0());
}
var static_init_called_0;
function static_init_0() {
  if (static_init_called_0)
    return Unit_instance;
  static_init_called_0 = true;
  CareLocationType_Center_instance = new (CareLocationType())('Center', 0, 'Center');
  CareLocationType_FamilyChildCare_instance = new (CareLocationType())('FamilyChildCare', 1, 'Family Child Care (independent)');
  CareLocationType_SystemFamilyChildCare_instance = new (CareLocationType())('SystemFamilyChildCare', 2, 'Family Child Care (system member)');
  if (Companion_instance_6 === VOID) {
    Companion_instance;
    new (Companion_4())();
  }
}
var CareLocationType_Center_instance;
var CareLocationType_FamilyChildCare_instance;
var CareLocationType_SystemFamilyChildCare_instance;
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      constructor() {
        Companion_instance_6 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, CareLocationType$Companion$_anonymous__l8avg1);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_6;
function Companion_getInstance_9() {
  static_init_0();
  return Companion_instance_6;
}
function values_0() {
  static_init_0();
  return [CareLocationType_Center_getInstance(), CareLocationType_FamilyChildCare_getInstance(), CareLocationType_SystemFamilyChildCare_getInstance()];
}
function get_entries_1() {
  static_init_0();
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_0());
  return $ENTRIES_0;
}
var $ENTRIES_0;
var CareLocationTypeClass;
function CareLocationType() {
  if (CareLocationTypeClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName) {
        super(name, ordinal);
        this.displayName_1 = displayName;
      }
    }
    initMetadataForClass($, 'CareLocationType', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_9});
    CareLocationTypeClass = $;
  }
  return CareLocationTypeClass;
}
function _ID___init__impl__k1lb7e_1(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_1($this) {
  return $this;
}
function ID__toString_impl_y5caka_2($this) {
  return _ID___get_raw__impl__92g6u5_1($this).toString();
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_14();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_7;
function Companion_getInstance_10() {
  return Companion_instance_7;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.CareProvider.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(CareProvider())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_1fe0pm_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_1(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_1fe0pm_k$(encoder, value instanceof ID_2() ? value.raw_1 : THROW_CCE());
      }
      deserialize_myqtth_k$(decoder) {
        return _ID___init__impl__k1lb7e_1(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_2())(this.deserialize_myqtth_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_14() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
function ID__hashCode_impl_f4lulz_2($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_1($this, other) {
  if (!(other instanceof ID_2()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_1($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_2())(other instanceof ID_2() ? other.raw_1 : THROW_CCE()));
}
var IDClass_1;
function ID_2() {
  if (IDClass_1 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_1(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_2(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_2(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_1(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_1(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_14});
    IDClass_1 = $;
  }
  return IDClass_1;
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_15();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_8;
function Companion_getInstance_11() {
  return Companion_instance_8;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.CareProvider', this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('name', false);
        tmp0_serialDesc.addElement_5pzumi_k$('contact', true);
        tmp0_serialDesc.addElement_5pzumi_k$('vendorNumber', true);
        tmp0_serialDesc.addElement_5pzumi_k$('sync', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (AdminViewOnly())());
        tmp0_serialDesc.addElement_5pzumi_k$('offersTransportation', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('Whether this provider transports children. Off for everyone in the pilot.'));
        tmp0_serialDesc.addElement_5pzumi_k$('active', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['name', 'type', 'contact.name', 'contact.email', 'contact.phone']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['~name']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_67ybud_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_1(Companion_getInstance().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_14(), new (ID_2())(value._id_1));
        }
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.name_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !value.contact_1.equals(new (ContactInfo())())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance(), value.contact_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.vendorNumber_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, StringSerializer_getInstance(), value.vendorNumber_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.sync_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, $serializer_getInstance_4(), value.sync_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.offersTransportation_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 5, value.offersTransportation_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.active_1 === true)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 6, value.active_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_67ybud_k$(encoder, value instanceof CareProvider() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = false;
        var tmp10_local6 = false;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_14();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_2())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, $serializer_getInstance_4(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance_14();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (ID_2())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, $serializer_getInstance_4(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return CareProvider().new_org_thecommunitygroupinc_cares_CareProvider_toog5e_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_14(), StringSerializer_getInstance(), $serializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_4()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_15() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
var CareProviderClass;
function CareProvider() {
  if (CareProviderClass === VOID) {
    class $ {
      constructor(_id, name, contact, vendorNumber, sync, offersTransportation, active) {
        _id = _id === VOID ? _ID___init__impl__k1lb7e_1(Companion_getInstance().random_fimq0t_k$()) : _id;
        contact = contact === VOID ? new (ContactInfo())() : contact;
        vendorNumber = vendorNumber === VOID ? null : vendorNumber;
        sync = sync === VOID ? null : sync;
        offersTransportation = offersTransportation === VOID ? false : offersTransportation;
        active = active === VOID ? true : active;
        this._id_1 = _id;
        this.name_1 = name;
        this.contact_1 = contact;
        this.vendorNumber_1 = vendorNumber;
        this.sync_1 = sync;
        this.offersTransportation_1 = offersTransportation;
        this.active_1 = active;
      }
      get__id_mx6zky_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_2())(this.get__id_mx6zky_k$());
      }
      toString() {
        return 'CareProvider(_id=' + ID__toString_impl_y5caka_2(this._id_1) + ', name=' + this.name_1 + ', contact=' + this.contact_1.toString() + ', vendorNumber=' + this.vendorNumber_1 + ', sync=' + toString_0(this.sync_1) + ', offersTransportation=' + this.offersTransportation_1 + ', active=' + this.active_1 + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_2(this._id_1);
        result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
        result = imul(result, 31) + this.contact_1.hashCode() | 0;
        result = imul(result, 31) + (this.vendorNumber_1 == null ? 0 : getStringHashCode(this.vendorNumber_1)) | 0;
        result = imul(result, 31) + (this.sync_1 == null ? 0 : this.sync_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.offersTransportation_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.active_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CareProvider()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!this.contact_1.equals(other.contact_1))
          return false;
        if (!(this.vendorNumber_1 == other.vendorNumber_1))
          return false;
        if (!equals(this.sync_1, other.sync_1))
          return false;
        if (!(this.offersTransportation_1 === other.offersTransportation_1))
          return false;
        if (!(this.active_1 === other.active_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_CareProvider_toog5e_k$(seen0, _id, name, contact, vendorNumber, sync, offersTransportation, active, serializationConstructorMarker) {
        if (!(2 === (2 & seen0))) {
          throwMissingFieldException(seen0, 2, $serializer_getInstance_15().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_1(Companion_getInstance().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.name_1 = name;
        if (0 === (seen0 & 4))
          $this.contact_1 = new (ContactInfo())();
        else
          $this.contact_1 = contact;
        if (0 === (seen0 & 8))
          $this.vendorNumber_1 = null;
        else
          $this.vendorNumber_1 = vendorNumber;
        if (0 === (seen0 & 16))
          $this.sync_1 = null;
        else
          $this.sync_1 = sync;
        if (0 === (seen0 & 32))
          $this.offersTransportation_1 = false;
        else
          $this.offersTransportation_1 = offersTransportation;
        if (0 === (seen0 & 64))
          $this.active_1 = true;
        else
          $this.active_1 = active;
        return $this;
      }
    }
    initMetadataForClass($, 'CareProvider', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_15});
    CareProviderClass = $;
  }
  return CareProviderClass;
}
function _ID___init__impl__k1lb7e_2(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_2($this) {
  return $this;
}
function ID__toString_impl_y5caka_3($this) {
  return _ID___get_raw__impl__92g6u5_2($this).toString();
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_16();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_9;
function Companion_getInstance_12() {
  return Companion_instance_9;
}
var $serializerClass_5;
function $serializer_5() {
  if ($serializerClass_5 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_5 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.ChildPlacement.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(ChildPlacement())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_rz1xcj_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_2(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_rz1xcj_k$(encoder, value instanceof ID_3() ? value.raw_1 : THROW_CCE());
      }
      deserialize_cp4zq4_k$(decoder) {
        return _ID___init__impl__k1lb7e_2(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_3())(this.deserialize_cp4zq4_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_5 = $;
  }
  return $serializerClass_5;
}
var $serializer_instance_5;
function $serializer_getInstance_16() {
  if ($serializer_instance_5 === VOID)
    new ($serializer_5())();
  return $serializer_instance_5;
}
function ID__hashCode_impl_f4lulz_3($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_2($this, other) {
  if (!(other instanceof ID_3()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_2($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_3())(other instanceof ID_3() ? other.raw_1 : THROW_CCE()));
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function ChildPlacement$EndReason$Companion$_anonymous__w0u99n() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.ChildPlacement.EndReason', values_1());
}
var static_init_called_1;
function static_init_1() {
  if (static_init_called_1)
    return Unit_instance;
  static_init_called_1 = true;
  EndReason_AgedOut_instance = new (EndReason())('AgedOut', 0, 'Aged out');
  EndReason_ExcessiveAbsences_instance = new (EndReason())('ExcessiveAbsences', 1, 'Excessive Absences');
  EndReason_Behavior_instance = new (EndReason())('Behavior', 2, 'Term for Health/Safety (Behavior)');
  EndReason_Voluntary_instance = new (EndReason())('Voluntary', 3, 'Voluntary Term by parent');
  EndReason_ProviderChange_instance = new (EndReason())('ProviderChange', 4, 'Provider change');
  EndReason_NotFollowingPolicies_instance = new (EndReason())('NotFollowingPolicies', 5, 'Not following Center/Program Policies');
  EndReason_NonPayment_instance = new (EndReason())('NonPayment', 6, 'Non-payment of parent portion');
  EndReason_Employer_instance = new (EndReason())('Employer', 7, 'Employer term \u2013 parent left employer');
  EndReason_Other_instance = new (EndReason())('Other', 8, 'Other');
  if (Companion_instance_10 === VOID) {
    Companion_instance;
    new (Companion_8())();
  }
}
var EndReason_AgedOut_instance;
var EndReason_ExcessiveAbsences_instance;
var EndReason_Behavior_instance;
var EndReason_Voluntary_instance;
var EndReason_ProviderChange_instance;
var EndReason_NotFollowingPolicies_instance;
var EndReason_NonPayment_instance;
var EndReason_Employer_instance;
var EndReason_Other_instance;
function values_1() {
  static_init_1();
  return [EndReason_AgedOut_getInstance(), EndReason_ExcessiveAbsences_getInstance(), EndReason_Behavior_getInstance(), EndReason_Voluntary_getInstance(), EndReason_ProviderChange_getInstance(), EndReason_NotFollowingPolicies_getInstance(), EndReason_NonPayment_getInstance(), EndReason_Employer_getInstance(), EndReason_Other_getInstance()];
}
function get_entries_2() {
  static_init_1();
  if ($ENTRIES_1 == null)
    $ENTRIES_1 = enumEntries(values_1());
  return $ENTRIES_1;
}
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {
      constructor() {
        Companion_instance_10 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, ChildPlacement$EndReason$Companion$_anonymous__w0u99n);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_10;
function Companion_getInstance_13() {
  static_init_1();
  return Companion_instance_10;
}
var $ENTRIES_1;
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_17();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_11;
function Companion_getInstance_14() {
  return Companion_instance_11;
}
var $serializerClass_6;
function $serializer_6() {
  if ($serializerClass_6 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_6 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.ChildPlacement.SignedDocument', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('file', false);
        tmp0_serialDesc.addElement_5pzumi_k$('at', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_pyln5t_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, DeferToContextualServerFileSerializer_getInstance(), new (ServerFile())(value.file_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, InstantSerializer_getInstance(), value.at_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_pyln5t_k$(encoder, value instanceof SignedDocument() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          var tmp = DeferToContextualServerFileSerializer_getInstance();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ServerFile())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.location_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, InstantSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = DeferToContextualServerFileSerializer_getInstance();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (ServerFile())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.location_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, InstantSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return SignedDocument().new_org_thecommunitygroupinc_cares_ChildPlacement_SignedDocument_sdhf4v_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DeferToContextualServerFileSerializer_getInstance(), InstantSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_6 = $;
  }
  return $serializerClass_6;
}
var $serializer_instance_6;
function $serializer_getInstance_17() {
  if ($serializer_instance_6 === VOID)
    new ($serializer_6())();
  return $serializer_instance_6;
}
var CompanionClass_10;
function Companion_10() {
  if (CompanionClass_10 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_18();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_10 = $;
  }
  return CompanionClass_10;
}
var Companion_instance_12;
function Companion_getInstance_15() {
  return Companion_instance_12;
}
var $serializerClass_7;
function $serializer_7() {
  if ($serializerClass_7 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_7 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.ChildPlacement.Schedule.Day', this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('program', false);
        tmp0_serialDesc.addElement_5pzumi_k$('transportFrom', true);
        tmp0_serialDesc.addElement_5pzumi_k$('transportTo', true);
        tmp0_serialDesc.addElement_5pzumi_k$('programWhenIntermittent', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_s378kx_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_7(), new (ID())(value.program_1));
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.transportFrom_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 1, value.transportFrom_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.transportTo_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 2, value.transportTo_1);
        }
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3)) {
          tmp = true;
        } else {
          var tmp_0 = value.programWhenIntermittent_1;
          tmp = !((tmp_0 == null ? null : new (ID())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = $serializer_getInstance_7();
          var tmp_2 = value.programWhenIntermittent_1;
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, tmp_1, tmp_2 == null ? null : new (ID())(tmp_2));
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_s378kx_k$(encoder, value instanceof Day() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp6_local2 = false;
        var tmp7_local3 = null;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_7();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp_2 = $serializer_getInstance_7();
          var tmp_3 = tmp7_local3;
          var tmp_4 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, tmp_2, tmp_3 == null ? null : new (ID())(tmp_3));
          tmp7_local3 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_5 = $serializer_getInstance_7();
                var tmp_6 = tmp4_local0;
                var tmp_7 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_5, tmp_6 == null ? null : new (ID())(tmp_6));
                tmp4_local0 = tmp_7 == null ? null : tmp_7.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_8 = $serializer_getInstance_7();
                var tmp_9 = tmp7_local3;
                var tmp_10 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, tmp_8, tmp_9 == null ? null : new (ID())(tmp_9));
                tmp7_local3 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Day().new_org_thecommunitygroupinc_cares_ChildPlacement_Schedule_Day_hcofie_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_7(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable($serializer_getInstance_7())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_7 = $;
  }
  return $serializerClass_7;
}
var $serializer_instance_7;
function $serializer_getInstance_18() {
  if ($serializer_instance_7 === VOID)
    new ($serializer_7())();
  return $serializer_instance_7;
}
var DayClass;
function Day() {
  if (DayClass === VOID) {
    class $ {
      constructor(program, transportFrom, transportTo, programWhenIntermittent) {
        transportFrom = transportFrom === VOID ? false : transportFrom;
        transportTo = transportTo === VOID ? false : transportTo;
        programWhenIntermittent = programWhenIntermittent === VOID ? null : programWhenIntermittent;
        this.program_1 = program;
        this.transportFrom_1 = transportFrom;
        this.transportTo_1 = transportTo;
        this.programWhenIntermittent_1 = programWhenIntermittent;
      }
      scheduled_uf1us3_k$(programs) {
        var tmp = programs(new (ID())(this.program_1)).careTime_1;
        var tmp0_safe_receiver = this.programWhenIntermittent_1;
        var tmp_0;
        var tmp_1 = tmp0_safe_receiver;
        if ((tmp_1 == null ? null : new (ID())(tmp_1)) == null) {
          tmp_0 = null;
        } else {
          var tmp_2 = tmp0_safe_receiver;
          // Inline function 'kotlin.let' call
          var it = (tmp_2 == null ? null : new (ID())(tmp_2)).raw_1;
          tmp_0 = programs(new (ID())(it)).careTime_1;
        }
        return new (ScheduledAttendance())(tmp, this.transportFrom_1, this.transportTo_1, tmp_0);
      }
      copy_nl1ka2_k$(program, transportFrom, transportTo, programWhenIntermittent) {
        return new (Day())(program, transportFrom, transportTo, programWhenIntermittent);
      }
      copy$default_yokad6_k$(program, transportFrom, transportTo, programWhenIntermittent, $super) {
        program = program === VOID ? this.program_1 : program;
        transportFrom = transportFrom === VOID ? this.transportFrom_1 : transportFrom;
        transportTo = transportTo === VOID ? this.transportTo_1 : transportTo;
        programWhenIntermittent = programWhenIntermittent === VOID ? this.programWhenIntermittent_1 : programWhenIntermittent;
        var tmp;
        if ($super === VOID) {
          tmp = this.copy_nl1ka2_k$(program, transportFrom, transportTo, programWhenIntermittent);
        } else {
          var tmp_0 = $super.copy_nl1ka2_k$;
          var tmp_1 = programWhenIntermittent;
          tmp = tmp_0.call(this, new (ID())(program), transportFrom, transportTo, tmp_1 == null ? null : new (ID())(tmp_1));
        }
        return tmp;
      }
      toString() {
        var tmp = ID__toString_impl_y5caka(this.program_1);
        var tmp_0 = this.programWhenIntermittent_1;
        return 'Day(program=' + tmp + ', transportFrom=' + this.transportFrom_1 + ', transportTo=' + this.transportTo_1 + ', programWhenIntermittent=' + toString_0(tmp_0 == null ? null : new (ID())(tmp_0)) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz(this.program_1);
        result = imul(result, 31) + getBooleanHashCode(this.transportFrom_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.transportTo_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.programWhenIntermittent_1;
        if ((tmp_1 == null ? null : new (ID())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = ID__hashCode_impl_f4lulz(this.programWhenIntermittent_1);
        }
        result = tmp + tmp_0 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Day()))
          return false;
        if (!equals(this.program_1, other.program_1))
          return false;
        if (!(this.transportFrom_1 === other.transportFrom_1))
          return false;
        if (!(this.transportTo_1 === other.transportTo_1))
          return false;
        var tmp = this.programWhenIntermittent_1;
        var tmp_0 = tmp == null ? null : new (ID())(tmp);
        var tmp_1 = other.programWhenIntermittent_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ID())(tmp_1)))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_ChildPlacement_Schedule_Day_hcofie_k$(seen0, program, transportFrom, transportTo, programWhenIntermittent, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_18().descriptor_1);
        }
        var $this = createThis(this);
        $this.program_1 = program;
        if (0 === (seen0 & 2))
          $this.transportFrom_1 = false;
        else
          $this.transportFrom_1 = transportFrom;
        if (0 === (seen0 & 4))
          $this.transportTo_1 = false;
        else
          $this.transportTo_1 = transportTo;
        if (0 === (seen0 & 8))
          $this.programWhenIntermittent_1 = null;
        else
          $this.programWhenIntermittent_1 = programWhenIntermittent;
        return $this;
      }
    }
    initMetadataForClass($, 'Day', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_18});
    DayClass = $;
  }
  return DayClass;
}
var CompanionClass_11;
function Companion_11() {
  if (CompanionClass_11 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_19();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_11 = $;
  }
  return CompanionClass_11;
}
var Companion_instance_13;
function Companion_getInstance_16() {
  return Companion_instance_13;
}
var $serializerClass_8;
function $serializer_8() {
  if ($serializerClass_8 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_8 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.ChildPlacement.Schedule', this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('monday', true);
        tmp0_serialDesc.addElement_5pzumi_k$('tuesday', true);
        tmp0_serialDesc.addElement_5pzumi_k$('wednesday', true);
        tmp0_serialDesc.addElement_5pzumi_k$('thursday', true);
        tmp0_serialDesc.addElement_5pzumi_k$('friday', true);
        tmp0_serialDesc.addElement_5pzumi_k$('saturday', true);
        tmp0_serialDesc.addElement_5pzumi_k$('sunday', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_mfb1c1_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.monday_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, $serializer_getInstance_18(), value.monday_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.tuesday_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, $serializer_getInstance_18(), value.tuesday_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.wednesday_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, $serializer_getInstance_18(), value.wednesday_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.thursday_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, $serializer_getInstance_18(), value.thursday_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.friday_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, $serializer_getInstance_18(), value.friday_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.saturday_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, $serializer_getInstance_18(), value.saturday_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.sunday_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 6, $serializer_getInstance_18(), value.sunday_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_mfb1c1_k$(encoder, value instanceof Schedule() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, $serializer_getInstance_18(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, $serializer_getInstance_18(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, $serializer_getInstance_18(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, $serializer_getInstance_18(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, $serializer_getInstance_18(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, $serializer_getInstance_18(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, $serializer_getInstance_18(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, $serializer_getInstance_18(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, $serializer_getInstance_18(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, $serializer_getInstance_18(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, $serializer_getInstance_18(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, $serializer_getInstance_18(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, $serializer_getInstance_18(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, $serializer_getInstance_18(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Schedule().new_org_thecommunitygroupinc_cares_ChildPlacement_Schedule_k0n65y_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable($serializer_getInstance_18()), get_nullable($serializer_getInstance_18()), get_nullable($serializer_getInstance_18()), get_nullable($serializer_getInstance_18()), get_nullable($serializer_getInstance_18()), get_nullable($serializer_getInstance_18()), get_nullable($serializer_getInstance_18())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_8 = $;
  }
  return $serializerClass_8;
}
var $serializer_instance_8;
function $serializer_getInstance_19() {
  if ($serializer_instance_8 === VOID)
    new ($serializer_8())();
  return $serializer_instance_8;
}
function ChildPlacement$Companion$$childSerializers$_anonymous__rdt7nj() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_27());
}
function ChildPlacement$Companion$$childSerializers$_anonymous__rdt7nj_0() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_10());
}
function ChildPlacement$Companion$$childSerializers$_anonymous__rdt7nj_1() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_12());
}
function ChildPlacement$Companion$$childSerializers$_anonymous__rdt7nj_2() {
  return Companion_getInstance_13().serializer_9w0wvi_k$();
}
var IDClass_2;
function ID_3() {
  if (IDClass_2 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_2(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_3(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_3(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_2(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_2(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_16});
    IDClass_2 = $;
  }
  return IDClass_2;
}
var EndReasonClass;
function EndReason() {
  if (EndReasonClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName) {
        super(name, ordinal);
        this.displayName_1 = displayName;
      }
    }
    initMetadataForClass($, 'EndReason', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_13});
    EndReasonClass = $;
  }
  return EndReasonClass;
}
var SignedDocumentClass;
function SignedDocument() {
  if (SignedDocumentClass === VOID) {
    class $ {
      constructor(file, at) {
        this.file_1 = file;
        this.at_1 = at;
      }
      toString() {
        return 'SignedDocument(file=' + ServerFile__toString_impl_4rulpa(this.file_1) + ', at=' + this.at_1.toString() + ')';
      }
      hashCode() {
        var result = ServerFile__hashCode_impl_qj0ii5(this.file_1);
        result = imul(result, 31) + this.at_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SignedDocument()))
          return false;
        if (!(this.file_1 === other.file_1))
          return false;
        if (!this.at_1.equals(other.at_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_ChildPlacement_SignedDocument_sdhf4v_k$(seen0, file, at, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_17().descriptor_1);
        }
        var $this = createThis(this);
        $this.file_1 = file;
        $this.at_1 = at;
        return $this;
      }
    }
    initMetadataForClass($, 'SignedDocument', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_17});
    SignedDocumentClass = $;
  }
  return SignedDocumentClass;
}
var ScheduleClass;
function Schedule() {
  if (ScheduleClass === VOID) {
    class $ {
      constructor(monday, tuesday, wednesday, thursday, friday, saturday, sunday) {
        monday = monday === VOID ? null : monday;
        tuesday = tuesday === VOID ? null : tuesday;
        wednesday = wednesday === VOID ? null : wednesday;
        thursday = thursday === VOID ? null : thursday;
        friday = friday === VOID ? null : friday;
        saturday = saturday === VOID ? null : saturday;
        sunday = sunday === VOID ? null : sunday;
        this.monday_1 = monday;
        this.tuesday_1 = tuesday;
        this.wednesday_1 = wednesday;
        this.thursday_1 = thursday;
        this.friday_1 = friday;
        this.saturday_1 = saturday;
        this.sunday_1 = sunday;
      }
      get_all_18j9hk_k$() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = get_entries();
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$2 = this.get_riprg6_k$(item);
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        return destination;
      }
      get_programs_mo5naw_k$() {
        // Inline function 'kotlin.collections.flatMap' call
        var tmp0 = get_entries();
        // Inline function 'kotlin.collections.flatMapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          var tmp0_safe_receiver = this.get_riprg6_k$(element);
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp_0 = tmp0_safe_receiver.programWhenIntermittent_1;
            tmp = listOfNotNull([new (ID())(tmp0_safe_receiver.program_1), tmp_0 == null ? null : new (ID())(tmp_0)]);
          }
          var tmp1_elvis_lhs = tmp;
          var tmp_1;
          if (tmp1_elvis_lhs == null) {
            // Inline function 'kotlin.collections.listOf' call
            tmp_1 = emptyList();
          } else {
            tmp_1 = tmp1_elvis_lhs;
          }
          var list = tmp_1;
          addAll(destination, list);
        }
        return toSet(destination);
      }
      get_riprg6_k$(day) {
        var tmp;
        switch (day.ordinal_1) {
          case 0:
            tmp = this.monday_1;
            break;
          case 1:
            tmp = this.tuesday_1;
            break;
          case 2:
            tmp = this.wednesday_1;
            break;
          case 3:
            tmp = this.thursday_1;
            break;
          case 4:
            tmp = this.friday_1;
            break;
          case 5:
            tmp = this.saturday_1;
            break;
          case 6:
            tmp = this.sunday_1;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return tmp;
      }
      copy_tnb36q_k$(day, value) {
        var tmp;
        switch (day.ordinal_1) {
          case 0:
            tmp = this.copy$default_u7zwkh_k$(value);
            break;
          case 1:
            tmp = this.copy$default_u7zwkh_k$(VOID, value);
            break;
          case 2:
            tmp = this.copy$default_u7zwkh_k$(VOID, VOID, value);
            break;
          case 3:
            tmp = this.copy$default_u7zwkh_k$(VOID, VOID, VOID, value);
            break;
          case 4:
            tmp = this.copy$default_u7zwkh_k$(VOID, VOID, VOID, VOID, value);
            break;
          case 5:
            tmp = this.copy$default_u7zwkh_k$(VOID, VOID, VOID, VOID, VOID, value);
            break;
          case 6:
            tmp = this.copy$default_u7zwkh_k$(VOID, VOID, VOID, VOID, VOID, VOID, value);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return tmp;
      }
      copy_bvtrj2_k$(monday, tuesday, wednesday, thursday, friday, saturday, sunday) {
        return new (Schedule())(monday, tuesday, wednesday, thursday, friday, saturday, sunday);
      }
      copy$default_u7zwkh_k$(monday, tuesday, wednesday, thursday, friday, saturday, sunday, $super) {
        monday = monday === VOID ? this.monday_1 : monday;
        tuesday = tuesday === VOID ? this.tuesday_1 : tuesday;
        wednesday = wednesday === VOID ? this.wednesday_1 : wednesday;
        thursday = thursday === VOID ? this.thursday_1 : thursday;
        friday = friday === VOID ? this.friday_1 : friday;
        saturday = saturday === VOID ? this.saturday_1 : saturday;
        sunday = sunday === VOID ? this.sunday_1 : sunday;
        return $super === VOID ? this.copy_bvtrj2_k$(monday, tuesday, wednesday, thursday, friday, saturday, sunday) : $super.copy_bvtrj2_k$.call(this, monday, tuesday, wednesday, thursday, friday, saturday, sunday);
      }
      toString() {
        return 'Schedule(monday=' + toString_0(this.monday_1) + ', tuesday=' + toString_0(this.tuesday_1) + ', wednesday=' + toString_0(this.wednesday_1) + ', thursday=' + toString_0(this.thursday_1) + ', friday=' + toString_0(this.friday_1) + ', saturday=' + toString_0(this.saturday_1) + ', sunday=' + toString_0(this.sunday_1) + ')';
      }
      hashCode() {
        var result = this.monday_1 == null ? 0 : this.monday_1.hashCode();
        result = imul(result, 31) + (this.tuesday_1 == null ? 0 : this.tuesday_1.hashCode()) | 0;
        result = imul(result, 31) + (this.wednesday_1 == null ? 0 : this.wednesday_1.hashCode()) | 0;
        result = imul(result, 31) + (this.thursday_1 == null ? 0 : this.thursday_1.hashCode()) | 0;
        result = imul(result, 31) + (this.friday_1 == null ? 0 : this.friday_1.hashCode()) | 0;
        result = imul(result, 31) + (this.saturday_1 == null ? 0 : this.saturday_1.hashCode()) | 0;
        result = imul(result, 31) + (this.sunday_1 == null ? 0 : this.sunday_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Schedule()))
          return false;
        if (!equals(this.monday_1, other.monday_1))
          return false;
        if (!equals(this.tuesday_1, other.tuesday_1))
          return false;
        if (!equals(this.wednesday_1, other.wednesday_1))
          return false;
        if (!equals(this.thursday_1, other.thursday_1))
          return false;
        if (!equals(this.friday_1, other.friday_1))
          return false;
        if (!equals(this.saturday_1, other.saturday_1))
          return false;
        if (!equals(this.sunday_1, other.sunday_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_ChildPlacement_Schedule_k0n65y_k$(seen0, monday, tuesday, wednesday, thursday, friday, saturday, sunday, serializationConstructorMarker) {
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_19().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.monday_1 = null;
        else
          $this.monday_1 = monday;
        if (0 === (seen0 & 2))
          $this.tuesday_1 = null;
        else
          $this.tuesday_1 = tuesday;
        if (0 === (seen0 & 4))
          $this.wednesday_1 = null;
        else
          $this.wednesday_1 = wednesday;
        if (0 === (seen0 & 8))
          $this.thursday_1 = null;
        else
          $this.thursday_1 = thursday;
        if (0 === (seen0 & 16))
          $this.friday_1 = null;
        else
          $this.friday_1 = friday;
        if (0 === (seen0 & 32))
          $this.saturday_1 = null;
        else
          $this.saturday_1 = saturday;
        if (0 === (seen0 & 64))
          $this.sunday_1 = null;
        else
          $this.sunday_1 = sunday;
        return $this;
      }
    }
    initMetadataForClass($, 'Schedule', Schedule, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_19});
    ScheduleClass = $;
  }
  return ScheduleClass;
}
var CompanionClass_12;
function Companion_12() {
  if (CompanionClass_12 === VOID) {
    class $ {
      constructor() {
        Companion_instance_14 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ChildPlacement$Companion$$childSerializers$_anonymous__rdt7nj);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ChildPlacement$Companion$$childSerializers$_anonymous__rdt7nj_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, ChildPlacement$Companion$$childSerializers$_anonymous__rdt7nj_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, null, null, null, null, tmp_1, tmp_3, tmp_5, null, null, lazy(tmp_6, ChildPlacement$Companion$$childSerializers$_anonymous__rdt7nj_2), null, null, null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_20();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_12 = $;
  }
  return CompanionClass_12;
}
var Companion_instance_14;
function Companion_getInstance_17() {
  if (Companion_instance_14 === VOID)
    new (Companion_12())();
  return Companion_instance_14;
}
var $serializerClass_9;
function $serializer_9() {
  if ($serializerClass_9 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_9 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.ChildPlacement', this, 17);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('child', false);
        tmp0_serialDesc.addElement_5pzumi_k$('childName', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('childBirthDate', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('family', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('location', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.addElement_5pzumi_k$('provider', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('authorizations', true);
        tmp0_serialDesc.addElement_5pzumi_k$('employers', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('grants', true);
        tmp0_serialDesc.addElement_5pzumi_k$('schedule', true);
        tmp0_serialDesc.addElement_5pzumi_k$('activeRange', false);
        tmp0_serialDesc.addElement_5pzumi_k$('endReason', true);
        tmp0_serialDesc.addElement_5pzumi_k$('endReasonNotes', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Multiline())());
        tmp0_serialDesc.addElement_5pzumi_k$('signingInfo', true);
        tmp0_serialDesc.addElement_5pzumi_k$('signedDocument', true);
        tmp0_serialDesc.addElement_5pzumi_k$('active', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (IndexSet())(['signingInfo.envelopeId']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['childName', 'activeRange.start']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['childName', 'location', 'activeRange.start', 'activeRange.endInclusive']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['-activeRange.start', '~childName']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_mbrple_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_17().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_2(Companion_getInstance().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_16(), new (ID_3())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_29(), new (ID_7())(value.child_1));
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.childName_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, LocalDateSerializer_getInstance(), value.childBirthDate_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, $serializer_getInstance_21(), new (ID_4())(value.family_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, $serializer_getInstance_23(), new (ID_5())(value.location_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 6, $serializer_getInstance_14(), new (ID_2())(value.provider_1));
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 7)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp = !equals(value.authorizations_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 7, tmp2_cached[7].get_value_j01efc_k$(), value.authorizations_1);
        }
        var tmp_0;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 8)) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$1 = emptySet();
          tmp_0 = !equals(value.employers_1, tmp$ret$1);
        }
        if (tmp_0) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 8, tmp2_cached[8].get_value_j01efc_k$(), value.employers_1);
        }
        var tmp_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 9)) {
          tmp_1 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$2 = emptySet();
          tmp_1 = !equals(value.grants_1, tmp$ret$2);
        }
        if (tmp_1) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 9, tmp2_cached[9].get_value_j01efc_k$(), value.grants_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 10) ? true : !value.schedule_1.equals(new (Schedule())())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 10, $serializer_getInstance_19(), value.schedule_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 11, $serializer_getInstance_1(), value.activeRange_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 12) ? true : !(value.endReason_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 12, tmp2_cached[12].get_value_j01efc_k$(), value.endReason_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 13) ? true : !(value.endReasonNotes_1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 13, value.endReasonNotes_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 14) ? true : !(value.signingInfo_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 14, $serializer_getInstance_6(), value.signingInfo_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 15) ? true : !(value.signedDocument_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 15, $serializer_getInstance_17(), value.signedDocument_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 16) ? true : !(value.active_1 === true)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 16, value.active_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_mbrple_k$(encoder, value instanceof ChildPlacement() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = null;
        var tmp18_local14 = null;
        var tmp19_local15 = null;
        var tmp20_local16 = false;
        var tmp21_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp22_cached = Companion_getInstance_17().$childSerializers_1;
        if (tmp21_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_16();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_3())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_29();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID_7())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp21_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, LocalDateSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp_5 = $serializer_getInstance_21();
          var tmp_6 = tmp8_local4;
          var tmp_7 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp_5, tmp_6 == null ? null : new (ID_4())(tmp_6));
          tmp8_local4 = tmp_7 == null ? null : tmp_7.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp_8 = $serializer_getInstance_23();
          var tmp_9 = tmp9_local5;
          var tmp_10 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp_8, tmp_9 == null ? null : new (ID_5())(tmp_9));
          tmp9_local5 = tmp_10 == null ? null : tmp_10.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          var tmp_11 = $serializer_getInstance_14();
          var tmp_12 = tmp10_local6;
          var tmp_13 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp_11, tmp_12 == null ? null : new (ID_2())(tmp_12));
          tmp10_local6 = tmp_13 == null ? null : tmp_13.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, tmp22_cached[7].get_value_j01efc_k$(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 8, tmp22_cached[8].get_value_j01efc_k$(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 9, tmp22_cached[9].get_value_j01efc_k$(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 10, $serializer_getInstance_19(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 11, $serializer_getInstance_1(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp21_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 12, tmp22_cached[12].get_value_j01efc_k$(), tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp21_input.decodeStringElement_3oenpg_k$(tmp0_desc, 13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp18_local14 = tmp21_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 14, $serializer_getInstance_6(), tmp18_local14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          tmp19_local15 = tmp21_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 15, $serializer_getInstance_17(), tmp19_local15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          tmp20_local16 = tmp21_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp21_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_14 = $serializer_getInstance_16();
                var tmp_15 = tmp4_local0;
                var tmp_16 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_14, tmp_15 == null ? null : new (ID_3())(tmp_15));
                tmp4_local0 = tmp_16 == null ? null : tmp_16.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_17 = $serializer_getInstance_29();
                var tmp_18 = tmp5_local1;
                var tmp_19 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_17, tmp_18 == null ? null : new (ID_7())(tmp_18));
                tmp5_local1 = tmp_19 == null ? null : tmp_19.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp21_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, LocalDateSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_20 = $serializer_getInstance_21();
                var tmp_21 = tmp8_local4;
                var tmp_22 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp_20, tmp_21 == null ? null : new (ID_4())(tmp_21));
                tmp8_local4 = tmp_22 == null ? null : tmp_22.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_23 = $serializer_getInstance_23();
                var tmp_24 = tmp9_local5;
                var tmp_25 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp_23, tmp_24 == null ? null : new (ID_5())(tmp_24));
                tmp9_local5 = tmp_25 == null ? null : tmp_25.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                var tmp_26 = $serializer_getInstance_14();
                var tmp_27 = tmp10_local6;
                var tmp_28 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp_26, tmp_27 == null ? null : new (ID_2())(tmp_27));
                tmp10_local6 = tmp_28 == null ? null : tmp_28.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, tmp22_cached[7].get_value_j01efc_k$(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 8, tmp22_cached[8].get_value_j01efc_k$(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 9, tmp22_cached[9].get_value_j01efc_k$(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 10, $serializer_getInstance_19(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp21_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 11, $serializer_getInstance_1(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp21_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 12, tmp22_cached[12].get_value_j01efc_k$(), tmp16_local12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp21_input.decodeStringElement_3oenpg_k$(tmp0_desc, 13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp18_local14 = tmp21_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 14, $serializer_getInstance_6(), tmp18_local14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              case 15:
                tmp19_local15 = tmp21_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 15, $serializer_getInstance_17(), tmp19_local15);
                tmp3_bitMask0 = tmp3_bitMask0 | 32768;
                break;
              case 16:
                tmp20_local16 = tmp21_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 16);
                tmp3_bitMask0 = tmp3_bitMask0 | 65536;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp21_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ChildPlacement().new_org_thecommunitygroupinc_cares_ChildPlacement_6y82gt_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_17().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_16(), $serializer_getInstance_29(), StringSerializer_getInstance(), LocalDateSerializer_getInstance(), $serializer_getInstance_21(), $serializer_getInstance_23(), $serializer_getInstance_14(), tmp0_cached[7].get_value_j01efc_k$(), tmp0_cached[8].get_value_j01efc_k$(), tmp0_cached[9].get_value_j01efc_k$(), $serializer_getInstance_19(), $serializer_getInstance_1(), get_nullable(tmp0_cached[12].get_value_j01efc_k$()), StringSerializer_getInstance(), get_nullable($serializer_getInstance_6()), get_nullable($serializer_getInstance_17()), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_9 = $;
  }
  return $serializerClass_9;
}
var $serializer_instance_9;
function $serializer_getInstance_20() {
  if ($serializer_instance_9 === VOID)
    new ($serializer_9())();
  return $serializer_instance_9;
}
function EndReason_AgedOut_getInstance() {
  static_init_1();
  return EndReason_AgedOut_instance;
}
function EndReason_ExcessiveAbsences_getInstance() {
  static_init_1();
  return EndReason_ExcessiveAbsences_instance;
}
function EndReason_Behavior_getInstance() {
  static_init_1();
  return EndReason_Behavior_instance;
}
function EndReason_Voluntary_getInstance() {
  static_init_1();
  return EndReason_Voluntary_instance;
}
function EndReason_ProviderChange_getInstance() {
  static_init_1();
  return EndReason_ProviderChange_instance;
}
function EndReason_NotFollowingPolicies_getInstance() {
  static_init_1();
  return EndReason_NotFollowingPolicies_instance;
}
function EndReason_NonPayment_getInstance() {
  static_init_1();
  return EndReason_NonPayment_instance;
}
function EndReason_Employer_getInstance() {
  static_init_1();
  return EndReason_Employer_instance;
}
function EndReason_Other_getInstance() {
  static_init_1();
  return EndReason_Other_instance;
}
var ChildPlacementClass;
function ChildPlacement() {
  if (ChildPlacementClass === VOID) {
    class $ {
      constructor(_id, child, childName, childBirthDate, family, location, provider, authorizations, employers, grants, schedule, activeRange, endReason, endReasonNotes, signingInfo, signedDocument, active) {
        Companion_getInstance_17();
        _id = _id === VOID ? _ID___init__impl__k1lb7e_2(Companion_getInstance().random_fimq0t_k$()) : _id;
        var tmp;
        if (authorizations === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = authorizations;
        }
        authorizations = tmp;
        var tmp_0;
        if (employers === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_0 = emptySet();
        } else {
          tmp_0 = employers;
        }
        employers = tmp_0;
        var tmp_1;
        if (grants === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_1 = emptySet();
        } else {
          tmp_1 = grants;
        }
        grants = tmp_1;
        schedule = schedule === VOID ? new (Schedule())() : schedule;
        endReason = endReason === VOID ? null : endReason;
        endReasonNotes = endReasonNotes === VOID ? '' : endReasonNotes;
        signingInfo = signingInfo === VOID ? null : signingInfo;
        signedDocument = signedDocument === VOID ? null : signedDocument;
        active = active === VOID ? true : active;
        this._id_1 = _id;
        this.child_1 = child;
        this.childName_1 = childName;
        this.childBirthDate_1 = childBirthDate;
        this.family_1 = family;
        this.location_1 = location;
        this.provider_1 = provider;
        this.authorizations_1 = authorizations;
        this.employers_1 = employers;
        this.grants_1 = grants;
        this.schedule_1 = schedule;
        this.activeRange_1 = activeRange;
        this.endReason_1 = endReason;
        this.endReasonNotes_1 = endReasonNotes;
        this.signingInfo_1 = signingInfo;
        this.signedDocument_1 = signedDocument;
        this.active_1 = active;
      }
      get__id_sph5x3_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_3())(this.get__id_sph5x3_k$());
      }
      toString() {
        return 'ChildPlacement(_id=' + ID__toString_impl_y5caka_3(this._id_1) + ', child=' + ID__toString_impl_y5caka_7(this.child_1) + ', childName=' + this.childName_1 + ', childBirthDate=' + this.childBirthDate_1.toString() + ', family=' + ID__toString_impl_y5caka_4(this.family_1) + ', location=' + ID__toString_impl_y5caka_5(this.location_1) + ', provider=' + ID__toString_impl_y5caka_2(this.provider_1) + ', authorizations=' + toString(this.authorizations_1) + ', employers=' + toString(this.employers_1) + ', grants=' + toString(this.grants_1) + ', schedule=' + this.schedule_1.toString() + ', activeRange=' + this.activeRange_1.toString() + ', endReason=' + toString_0(this.endReason_1) + ', endReasonNotes=' + this.endReasonNotes_1 + ', signingInfo=' + toString_0(this.signingInfo_1) + ', signedDocument=' + toString_0(this.signedDocument_1) + ', active=' + this.active_1 + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_3(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_7(this.child_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.childName_1) | 0;
        result = imul(result, 31) + this.childBirthDate_1.hashCode() | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_4(this.family_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_5(this.location_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_2(this.provider_1) | 0;
        result = imul(result, 31) + hashCode(this.authorizations_1) | 0;
        result = imul(result, 31) + hashCode(this.employers_1) | 0;
        result = imul(result, 31) + hashCode(this.grants_1) | 0;
        result = imul(result, 31) + this.schedule_1.hashCode() | 0;
        result = imul(result, 31) + this.activeRange_1.hashCode() | 0;
        result = imul(result, 31) + (this.endReason_1 == null ? 0 : this.endReason_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.endReasonNotes_1) | 0;
        result = imul(result, 31) + (this.signingInfo_1 == null ? 0 : this.signingInfo_1.hashCode()) | 0;
        result = imul(result, 31) + (this.signedDocument_1 == null ? 0 : this.signedDocument_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.active_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ChildPlacement()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.child_1, other.child_1))
          return false;
        if (!(this.childName_1 === other.childName_1))
          return false;
        if (!this.childBirthDate_1.equals(other.childBirthDate_1))
          return false;
        if (!equals(this.family_1, other.family_1))
          return false;
        if (!equals(this.location_1, other.location_1))
          return false;
        if (!equals(this.provider_1, other.provider_1))
          return false;
        if (!equals(this.authorizations_1, other.authorizations_1))
          return false;
        if (!equals(this.employers_1, other.employers_1))
          return false;
        if (!equals(this.grants_1, other.grants_1))
          return false;
        if (!this.schedule_1.equals(other.schedule_1))
          return false;
        if (!this.activeRange_1.equals(other.activeRange_1))
          return false;
        if (!equals(this.endReason_1, other.endReason_1))
          return false;
        if (!(this.endReasonNotes_1 === other.endReasonNotes_1))
          return false;
        if (!equals(this.signingInfo_1, other.signingInfo_1))
          return false;
        if (!equals(this.signedDocument_1, other.signedDocument_1))
          return false;
        if (!(this.active_1 === other.active_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_ChildPlacement_6y82gt_k$(seen0, _id, child, childName, childBirthDate, family, location, provider, authorizations, employers, grants, schedule, activeRange, endReason, endReasonNotes, signingInfo, signedDocument, active, serializationConstructorMarker) {
        Companion_getInstance_17();
        if (!(2174 === (2174 & seen0))) {
          throwMissingFieldException(seen0, 2174, $serializer_getInstance_20().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_2(Companion_getInstance().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.child_1 = child;
        $this.childName_1 = childName;
        $this.childBirthDate_1 = childBirthDate;
        $this.family_1 = family;
        $this.location_1 = location;
        $this.provider_1 = provider;
        if (0 === (seen0 & 128)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.authorizations_1 = emptySet();
        } else
          $this.authorizations_1 = authorizations;
        if (0 === (seen0 & 256)) {
          var tmp_0 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_0.employers_1 = emptySet();
        } else
          $this.employers_1 = employers;
        if (0 === (seen0 & 512)) {
          var tmp_1 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_1.grants_1 = emptySet();
        } else
          $this.grants_1 = grants;
        if (0 === (seen0 & 1024))
          $this.schedule_1 = new (Schedule())();
        else
          $this.schedule_1 = schedule;
        $this.activeRange_1 = activeRange;
        if (0 === (seen0 & 4096))
          $this.endReason_1 = null;
        else
          $this.endReason_1 = endReason;
        if (0 === (seen0 & 8192))
          $this.endReasonNotes_1 = '';
        else
          $this.endReasonNotes_1 = endReasonNotes;
        if (0 === (seen0 & 16384))
          $this.signingInfo_1 = null;
        else
          $this.signingInfo_1 = signingInfo;
        if (0 === (seen0 & 32768))
          $this.signedDocument_1 = null;
        else
          $this.signedDocument_1 = signedDocument;
        if (0 === (seen0 & 65536))
          $this.active_1 = true;
        else
          $this.active_1 = active;
        return $this;
      }
    }
    initMetadataForClass($, 'ChildPlacement', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_20});
    ChildPlacementClass = $;
  }
  return ChildPlacementClass;
}
function _ID___init__impl__k1lb7e_3(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_3($this) {
  return $this;
}
function ID__toString_impl_y5caka_4($this) {
  return _ID___get_raw__impl__92g6u5_3($this).toString();
}
var CompanionClass_13;
function Companion_13() {
  if (CompanionClass_13 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_21();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_13 = $;
  }
  return CompanionClass_13;
}
var Companion_instance_15;
function Companion_getInstance_18() {
  return Companion_instance_15;
}
var $serializerClass_10;
function $serializer_10() {
  if ($serializerClass_10 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_10 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.Family.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(Family())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_j8jui0_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_3(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_j8jui0_k$(encoder, value instanceof ID_4() ? value.raw_1 : THROW_CCE());
      }
      deserialize_50v5e1_k$(decoder) {
        return _ID___init__impl__k1lb7e_3(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_4())(this.deserialize_50v5e1_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_10 = $;
  }
  return $serializerClass_10;
}
var $serializer_instance_10;
function $serializer_getInstance_21() {
  if ($serializer_instance_10 === VOID)
    new ($serializer_10())();
  return $serializer_instance_10;
}
function ID__hashCode_impl_f4lulz_4($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_3($this, other) {
  if (!(other instanceof ID_4()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_3($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_4())(other instanceof ID_4() ? other.raw_1 : THROW_CCE()));
}
function Family$Companion$$childSerializers$_anonymous__u4w346() {
  return new (ArrayListSerializer())(StringSerializer_getInstance());
}
var IDClass_3;
function ID_4() {
  if (IDClass_3 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_3(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_4(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_4(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_3(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_3(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_21});
    IDClass_3 = $;
  }
  return IDClass_3;
}
var CompanionClass_14;
function Companion_14() {
  if (CompanionClass_14 === VOID) {
    class $ {
      constructor() {
        Companion_instance_16 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, null, lazy(tmp_0, Family$Companion$$childSerializers$_anonymous__u4w346), null, null, null, null, null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_22();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_14 = $;
  }
  return CompanionClass_14;
}
var Companion_instance_16;
function Companion_getInstance_19() {
  if (Companion_instance_16 === VOID)
    new (Companion_14())();
  return Companion_instance_16;
}
var $serializerClass_11;
function $serializer_11() {
  if ($serializerClass_11 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_11 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.Family', this, 11);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('shortId', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (AdminViewOnly())());
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())(IndexUniqueness_Unique_getInstance()));
        tmp0_serialDesc.addElement_5pzumi_k$('primaryParent', false);
        tmp0_serialDesc.addElement_5pzumi_k$('secondaryParent', true);
        tmp0_serialDesc.addElement_5pzumi_k$('childNames', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('income', false);
        tmp0_serialDesc.addElement_5pzumi_k$('familySize', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('Household size as reported by the family.'));
        tmp0_serialDesc.addElement_5pzumi_k$('address', false);
        tmp0_serialDesc.addElement_5pzumi_k$('mailingAddress', true);
        tmp0_serialDesc.addElement_5pzumi_k$('informationVerifiedAt', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('When TCG last confirmed these household details with the family.'));
        tmp0_serialDesc.addElement_5pzumi_k$('active', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['shortId', 'primaryParent.lastName', 'primaryParent.firstName']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['shortId', 'primaryParent.lastName', 'primaryParent.firstName', 'address.city', 'income', 'informationVerifiedAt']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['~primaryParent.lastName', '~primaryParent.firstName']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_yzc7yl_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_19().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_3(Companion_getInstance().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_21(), new (ID_4())(value._id_1));
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.shortId_1 === _ShortId___get_asString__impl__omz5t8(toShortId(_ID___get_raw__impl__92g6u5_3(value._id_1))))) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.shortId_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance_25(), value.primaryParent_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.secondaryParent_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, $serializer_getInstance_25(), value.secondaryParent_1);
        }
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.childNames_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, tmp2_cached[4].get_value_j01efc_k$(), value.childNames_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, $serializer_getInstance_26(), value.income_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.familySize_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 6, IntSerializer_getInstance(), value.familySize_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 7, $serializer_getInstance_0(), value.address_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 8) ? true : !(value.mailingAddress_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 8, $serializer_getInstance_0(), value.mailingAddress_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 9) ? true : !(value.informationVerifiedAt_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 9, LocalDateSerializer_getInstance(), value.informationVerifiedAt_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 10) ? true : !(value.active_1 === true)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 10, value.active_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_yzc7yl_k$(encoder, value instanceof Family() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = false;
        var tmp15_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp16_cached = Companion_getInstance_19().$childSerializers_1;
        if (tmp15_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_21();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_4())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_25(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp15_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, $serializer_getInstance_25(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp16_cached[4].get_value_j01efc_k$(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, $serializer_getInstance_26(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp15_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, $serializer_getInstance_0(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp15_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 8, $serializer_getInstance_0(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp15_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 9, LocalDateSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp15_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp15_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance_21();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (ID_4())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_25(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp15_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, $serializer_getInstance_25(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp16_cached[4].get_value_j01efc_k$(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, $serializer_getInstance_26(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp15_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, $serializer_getInstance_0(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp15_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 8, $serializer_getInstance_0(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp15_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 9, LocalDateSerializer_getInstance(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp15_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp15_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Family().new_org_thecommunitygroupinc_cares_Family_p95d2i_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_19().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_21(), StringSerializer_getInstance(), $serializer_getInstance_25(), get_nullable($serializer_getInstance_25()), tmp0_cached[4].get_value_j01efc_k$(), $serializer_getInstance_26(), get_nullable(IntSerializer_getInstance()), $serializer_getInstance_0(), get_nullable($serializer_getInstance_0()), get_nullable(LocalDateSerializer_getInstance()), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_11 = $;
  }
  return $serializerClass_11;
}
var $serializer_instance_11;
function $serializer_getInstance_22() {
  if ($serializer_instance_11 === VOID)
    new ($serializer_11())();
  return $serializer_instance_11;
}
var FamilyClass;
function Family() {
  if (FamilyClass === VOID) {
    class $ {
      constructor(_id, shortId, primaryParent, secondaryParent, childNames, income, familySize, address, mailingAddress, informationVerifiedAt, active) {
        Companion_getInstance_19();
        _id = _id === VOID ? _ID___init__impl__k1lb7e_3(Companion_getInstance().random_fimq0t_k$()) : _id;
        shortId = shortId === VOID ? _ShortId___get_asString__impl__omz5t8(toShortId(_ID___get_raw__impl__92g6u5_3(_id))) : shortId;
        secondaryParent = secondaryParent === VOID ? null : secondaryParent;
        var tmp;
        if (childNames === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = childNames;
        }
        childNames = tmp;
        familySize = familySize === VOID ? null : familySize;
        mailingAddress = mailingAddress === VOID ? null : mailingAddress;
        informationVerifiedAt = informationVerifiedAt === VOID ? null : informationVerifiedAt;
        active = active === VOID ? true : active;
        this._id_1 = _id;
        this.shortId_1 = shortId;
        this.primaryParent_1 = primaryParent;
        this.secondaryParent_1 = secondaryParent;
        this.childNames_1 = childNames;
        this.income_1 = income;
        this.familySize_1 = familySize;
        this.address_1 = address;
        this.mailingAddress_1 = mailingAddress;
        this.informationVerifiedAt_1 = informationVerifiedAt;
        this.active_1 = active;
      }
      get__id_jyoixw_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_4())(this.get__id_jyoixw_k$());
      }
      get_familyName_6ytaaw_k$() {
        // Inline function 'kotlin.text.trim' call
        var this_0 = this.primaryParent_1.lastName_1;
        var tmp = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
        var tmp0_safe_receiver = this.secondaryParent_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.text.trim' call
          var this_1 = tmp0_safe_receiver.lastName_1;
          var secondaryLastName = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
          var tmp_1;
          // Inline function 'kotlin.text.trim' call
          var this_2 = this.primaryParent_1.lastName_1;
          var tmp$ret$4 = toString(trim(isCharSequence(this_2) ? this_2 : THROW_CCE()));
          if (!equals_0(secondaryLastName, tmp$ret$4, true)) {
            tmp_1 = '-' + secondaryLastName;
          } else {
            tmp_1 = '';
          }
          tmp_0 = tmp_1;
        }
        var tmp1_elvis_lhs = tmp_0;
        return tmp + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
      }
      get_distinctName_5wyy9c_k$() {
        return this.get_familyName_6ytaaw_k$() + ', ' + this.primaryParent_1.firstName_1;
      }
      copy_ejiwgf_k$(_id, shortId, primaryParent, secondaryParent, childNames, income, familySize, address, mailingAddress, informationVerifiedAt, active) {
        return new (Family())(_id, shortId, primaryParent, secondaryParent, childNames, income, familySize, address, mailingAddress, informationVerifiedAt, active);
      }
      copy$default_8deers_k$(_id, shortId, primaryParent, secondaryParent, childNames, income, familySize, address, mailingAddress, informationVerifiedAt, active, $super) {
        _id = _id === VOID ? this._id_1 : _id;
        shortId = shortId === VOID ? this.shortId_1 : shortId;
        primaryParent = primaryParent === VOID ? this.primaryParent_1 : primaryParent;
        secondaryParent = secondaryParent === VOID ? this.secondaryParent_1 : secondaryParent;
        childNames = childNames === VOID ? this.childNames_1 : childNames;
        income = income === VOID ? this.income_1 : income;
        familySize = familySize === VOID ? this.familySize_1 : familySize;
        address = address === VOID ? this.address_1 : address;
        mailingAddress = mailingAddress === VOID ? this.mailingAddress_1 : mailingAddress;
        informationVerifiedAt = informationVerifiedAt === VOID ? this.informationVerifiedAt_1 : informationVerifiedAt;
        active = active === VOID ? this.active_1 : active;
        return $super === VOID ? this.copy_ejiwgf_k$(_id, shortId, primaryParent, secondaryParent, childNames, income, familySize, address, mailingAddress, informationVerifiedAt, active) : $super.copy_ejiwgf_k$.call(this, new (ID_4())(_id), shortId, primaryParent, secondaryParent, childNames, income, familySize, address, mailingAddress, informationVerifiedAt, active);
      }
      toString() {
        return 'Family(_id=' + ID__toString_impl_y5caka_4(this._id_1) + ', shortId=' + this.shortId_1 + ', primaryParent=' + this.primaryParent_1.toString() + ', secondaryParent=' + toString_0(this.secondaryParent_1) + ', childNames=' + toString(this.childNames_1) + ', income=' + this.income_1.toString() + ', familySize=' + this.familySize_1 + ', address=' + this.address_1.toString() + ', mailingAddress=' + toString_0(this.mailingAddress_1) + ', informationVerifiedAt=' + toString_0(this.informationVerifiedAt_1) + ', active=' + this.active_1 + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_4(this._id_1);
        result = imul(result, 31) + getStringHashCode(this.shortId_1) | 0;
        result = imul(result, 31) + this.primaryParent_1.hashCode() | 0;
        result = imul(result, 31) + (this.secondaryParent_1 == null ? 0 : this.secondaryParent_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.childNames_1) | 0;
        result = imul(result, 31) + this.income_1.hashCode() | 0;
        result = imul(result, 31) + (this.familySize_1 == null ? 0 : this.familySize_1) | 0;
        result = imul(result, 31) + this.address_1.hashCode() | 0;
        result = imul(result, 31) + (this.mailingAddress_1 == null ? 0 : this.mailingAddress_1.hashCode()) | 0;
        result = imul(result, 31) + (this.informationVerifiedAt_1 == null ? 0 : this.informationVerifiedAt_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.active_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Family()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!(this.shortId_1 === other.shortId_1))
          return false;
        if (!this.primaryParent_1.equals(other.primaryParent_1))
          return false;
        if (!equals(this.secondaryParent_1, other.secondaryParent_1))
          return false;
        if (!equals(this.childNames_1, other.childNames_1))
          return false;
        if (!this.income_1.equals(other.income_1))
          return false;
        if (!(this.familySize_1 == other.familySize_1))
          return false;
        if (!this.address_1.equals(other.address_1))
          return false;
        if (!equals(this.mailingAddress_1, other.mailingAddress_1))
          return false;
        if (!equals(this.informationVerifiedAt_1, other.informationVerifiedAt_1))
          return false;
        if (!(this.active_1 === other.active_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_Family_p95d2i_k$(seen0, _id, shortId, primaryParent, secondaryParent, childNames, income, familySize, address, mailingAddress, informationVerifiedAt, active, serializationConstructorMarker) {
        Companion_getInstance_19();
        if (!(164 === (164 & seen0))) {
          throwMissingFieldException(seen0, 164, $serializer_getInstance_22().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_3(Companion_getInstance().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        if (0 === (seen0 & 2))
          $this.shortId_1 = _ShortId___get_asString__impl__omz5t8(toShortId(_ID___get_raw__impl__92g6u5_3($this._id_1)));
        else
          $this.shortId_1 = shortId;
        $this.primaryParent_1 = primaryParent;
        if (0 === (seen0 & 8))
          $this.secondaryParent_1 = null;
        else
          $this.secondaryParent_1 = secondaryParent;
        if (0 === (seen0 & 16)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.childNames_1 = emptyList();
        } else
          $this.childNames_1 = childNames;
        $this.income_1 = income;
        if (0 === (seen0 & 64))
          $this.familySize_1 = null;
        else
          $this.familySize_1 = familySize;
        $this.address_1 = address;
        if (0 === (seen0 & 256))
          $this.mailingAddress_1 = null;
        else
          $this.mailingAddress_1 = mailingAddress;
        if (0 === (seen0 & 512))
          $this.informationVerifiedAt_1 = null;
        else
          $this.informationVerifiedAt_1 = informationVerifiedAt;
        if (0 === (seen0 & 1024))
          $this.active_1 = true;
        else
          $this.active_1 = active;
        return $this;
      }
    }
    initMetadataForClass($, 'Family', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_22});
    FamilyClass = $;
  }
  return FamilyClass;
}
function _ID___init__impl__k1lb7e_4(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_4($this) {
  return $this;
}
function ID__toString_impl_y5caka_5($this) {
  return _ID___get_raw__impl__92g6u5_4($this).toString();
}
var CompanionClass_15;
function Companion_15() {
  if (CompanionClass_15 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_23();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_15 = $;
  }
  return CompanionClass_15;
}
var Companion_instance_17;
function Companion_getInstance_20() {
  return Companion_instance_17;
}
var $serializerClass_12;
function $serializer_12() {
  if ($serializerClass_12 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_12 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.CareLocation.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(CareLocation())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_2px4ye_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_4(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_2px4ye_k$(encoder, value instanceof ID_5() ? value.raw_1 : THROW_CCE());
      }
      deserialize_n1xmbr_k$(decoder) {
        return _ID___init__impl__k1lb7e_4(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_5())(this.deserialize_n1xmbr_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_12 = $;
  }
  return $serializerClass_12;
}
var $serializer_instance_12;
function $serializer_getInstance_23() {
  if ($serializer_instance_12 === VOID)
    new ($serializer_12())();
  return $serializer_instance_12;
}
function ID__hashCode_impl_f4lulz_5($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_4($this, other) {
  if (!(other instanceof ID_5()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_4($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_5())(other instanceof ID_5() ? other.raw_1 : THROW_CCE()));
}
function CareLocation$Companion$$childSerializers$_anonymous__5kbsfw() {
  return Companion_getInstance_9().serializer_9w0wvi_k$();
}
var IDClass_4;
function ID_5() {
  if (IDClass_4 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_4(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_5(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_5(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_4(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_4(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_23});
    IDClass_4 = $;
  }
  return IDClass_4;
}
var CompanionClass_16;
function Companion_16() {
  if (CompanionClass_16 === VOID) {
    class $ {
      constructor() {
        Companion_instance_18 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, lazy(tmp_0, CareLocation$Companion$$childSerializers$_anonymous__5kbsfw), null, null, null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_24();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_16 = $;
  }
  return CompanionClass_16;
}
var Companion_instance_18;
function Companion_getInstance_21() {
  if (Companion_instance_18 === VOID)
    new (Companion_16())();
  return Companion_instance_18;
}
var $serializerClass_13;
function $serializer_13() {
  if ($serializerClass_13 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_13 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.CareLocation', this, 8);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('provider', false);
        tmp0_serialDesc.addElement_5pzumi_k$('providerName', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('type', false);
        tmp0_serialDesc.addElement_5pzumi_k$('name', false);
        tmp0_serialDesc.addElement_5pzumi_k$('address', false);
        tmp0_serialDesc.addElement_5pzumi_k$('contact', true);
        tmp0_serialDesc.addElement_5pzumi_k$('active', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['name', 'provider', 'address.city', 'contact.name', 'contact.phone']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['~name']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_3g20jz_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_21().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_4(Companion_getInstance().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_23(), new (ID_5())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_14(), new (ID_2())(value.provider_1));
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.providerName_1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.providerName_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, tmp2_cached[3].get_value_j01efc_k$(), value.type_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 4, value.name_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, $serializer_getInstance_0(), value.address_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !value.contact_1.equals(new (ContactInfo())())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 6, $serializer_getInstance(), value.contact_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 7) ? true : !(value.active_1 === true)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 7, value.active_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_3g20jz_k$(encoder, value instanceof CareLocation() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = false;
        var tmp12_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp13_cached = Companion_getInstance_21().$childSerializers_1;
        if (tmp12_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_23();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_5())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_14();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID_2())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp12_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp13_cached[3].get_value_j01efc_k$(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp12_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, $serializer_getInstance_0(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, $serializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp12_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp12_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_5 = $serializer_getInstance_23();
                var tmp_6 = tmp4_local0;
                var tmp_7 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_5, tmp_6 == null ? null : new (ID_5())(tmp_6));
                tmp4_local0 = tmp_7 == null ? null : tmp_7.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_8 = $serializer_getInstance_14();
                var tmp_9 = tmp5_local1;
                var tmp_10 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_8, tmp_9 == null ? null : new (ID_2())(tmp_9));
                tmp5_local1 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp12_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp13_cached[3].get_value_j01efc_k$(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp12_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, $serializer_getInstance_0(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, $serializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp12_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp12_input.endStructure_1xqz0n_k$(tmp0_desc);
        return CareLocation().new_org_thecommunitygroupinc_cares_CareLocation_v50d4z_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_21().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_23(), $serializer_getInstance_14(), StringSerializer_getInstance(), tmp0_cached[3].get_value_j01efc_k$(), StringSerializer_getInstance(), $serializer_getInstance_0(), $serializer_getInstance(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_13 = $;
  }
  return $serializerClass_13;
}
var $serializer_instance_13;
function $serializer_getInstance_24() {
  if ($serializer_instance_13 === VOID)
    new ($serializer_13())();
  return $serializer_instance_13;
}
var CareLocationClass;
function CareLocation() {
  if (CareLocationClass === VOID) {
    class $ {
      constructor(_id, provider, providerName, type, name, address, contact, active) {
        Companion_getInstance_21();
        _id = _id === VOID ? _ID___init__impl__k1lb7e_4(Companion_getInstance().random_fimq0t_k$()) : _id;
        providerName = providerName === VOID ? '' : providerName;
        contact = contact === VOID ? new (ContactInfo())() : contact;
        active = active === VOID ? true : active;
        this._id_1 = _id;
        this.provider_1 = provider;
        this.providerName_1 = providerName;
        this.type_1 = type;
        this.name_1 = name;
        this.address_1 = address;
        this.contact_1 = contact;
        this.active_1 = active;
      }
      get__id_n3hgka_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_5())(this.get__id_n3hgka_k$());
      }
      toString() {
        return 'CareLocation(_id=' + ID__toString_impl_y5caka_5(this._id_1) + ', provider=' + ID__toString_impl_y5caka_2(this.provider_1) + ', providerName=' + this.providerName_1 + ', type=' + toString(this.type_1) + ', name=' + this.name_1 + ', address=' + this.address_1.toString() + ', contact=' + this.contact_1.toString() + ', active=' + this.active_1 + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_5(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_2(this.provider_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.providerName_1) | 0;
        result = imul(result, 31) + this.type_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
        result = imul(result, 31) + this.address_1.hashCode() | 0;
        result = imul(result, 31) + this.contact_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.active_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CareLocation()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.provider_1, other.provider_1))
          return false;
        if (!(this.providerName_1 === other.providerName_1))
          return false;
        if (!this.type_1.equals(other.type_1))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!this.address_1.equals(other.address_1))
          return false;
        if (!this.contact_1.equals(other.contact_1))
          return false;
        if (!(this.active_1 === other.active_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_CareLocation_v50d4z_k$(seen0, _id, provider, providerName, type, name, address, contact, active, serializationConstructorMarker) {
        Companion_getInstance_21();
        if (!(58 === (58 & seen0))) {
          throwMissingFieldException(seen0, 58, $serializer_getInstance_24().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_4(Companion_getInstance().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.provider_1 = provider;
        if (0 === (seen0 & 4))
          $this.providerName_1 = '';
        else
          $this.providerName_1 = providerName;
        $this.type_1 = type;
        $this.name_1 = name;
        $this.address_1 = address;
        if (0 === (seen0 & 64))
          $this.contact_1 = new (ContactInfo())();
        else
          $this.contact_1 = contact;
        if (0 === (seen0 & 128))
          $this.active_1 = true;
        else
          $this.active_1 = active;
        return $this;
      }
    }
    initMetadataForClass($, 'CareLocation', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_24});
    CareLocationClass = $;
  }
  return CareLocationClass;
}
function Parent$Companion$$childSerializers$_anonymous__pc4mm8() {
  return new (LinkedHashSetSerializer())(Companion_getInstance_0().serializer_9w0wvi_k$());
}
function Parent$Companion$$childSerializers$_anonymous__pc4mm8_0() {
  return Companion_getInstance_1().serializer_9w0wvi_k$();
}
var CompanionClass_17;
function Companion_17() {
  if (CompanionClass_17 === VOID) {
    class $ {
      constructor() {
        Companion_instance_19 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Parent$Companion$$childSerializers$_anonymous__pc4mm8);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, null, null, null, tmp_1, lazy(tmp_2, Parent$Companion$$childSerializers$_anonymous__pc4mm8_0), null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_25();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_17 = $;
  }
  return CompanionClass_17;
}
var Companion_instance_19;
function Companion_getInstance_22() {
  if (Companion_instance_19 === VOID)
    new (Companion_17())();
  return Companion_instance_19;
}
var $serializerClass_14;
function $serializer_14() {
  if ($serializerClass_14 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_14 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.Parent', this, 9);
        tmp0_serialDesc.addElement_5pzumi_k$('firstName', false);
        tmp0_serialDesc.addElement_5pzumi_k$('lastName', false);
        tmp0_serialDesc.addElement_5pzumi_k$('email', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Group())('contact'));
        tmp0_serialDesc.addElement_5pzumi_k$('phone', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Group())('contact'));
        tmp0_serialDesc.addElement_5pzumi_k$('alternatePhone', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Group())('contact'));
        tmp0_serialDesc.addElement_5pzumi_k$('preferredLanguage', true);
        tmp0_serialDesc.addElement_5pzumi_k$('race', true);
        tmp0_serialDesc.addElement_5pzumi_k$('gender', true);
        tmp0_serialDesc.addElement_5pzumi_k$('birthDate', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_gd4eqp_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_22().$childSerializers_1;
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.firstName_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.lastName_1);
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2)) {
          tmp = true;
        } else {
          var tmp_0 = value.email_1;
          tmp = !((tmp_0 == null ? null : new (EmailAddress())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = EmailAddressSerializer_getInstance();
          var tmp_2 = value.email_1;
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, tmp_1, tmp_2 == null ? null : new (EmailAddress())(tmp_2));
        }
        var tmp_3;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3)) {
          tmp_3 = true;
        } else {
          var tmp_4 = value.phone_1;
          tmp_3 = !((tmp_4 == null ? null : new (PhoneNumber())(tmp_4)) == null);
        }
        if (tmp_3) {
          var tmp_5 = PhoneNumberSerializer_getInstance();
          var tmp_6 = value.phone_1;
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, tmp_5, tmp_6 == null ? null : new (PhoneNumber())(tmp_6));
        }
        var tmp_7;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4)) {
          tmp_7 = true;
        } else {
          var tmp_8 = value.alternatePhone_1;
          tmp_7 = !((tmp_8 == null ? null : new (PhoneNumber())(tmp_8)) == null);
        }
        if (tmp_7) {
          var tmp_9 = PhoneNumberSerializer_getInstance();
          var tmp_10 = value.alternatePhone_1;
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, tmp_9, tmp_10 == null ? null : new (PhoneNumber())(tmp_10));
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.preferredLanguage_1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 5, value.preferredLanguage_1);
        }
        var tmp_11;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6)) {
          tmp_11 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp_11 = !equals(value.race_1, tmp$ret$0);
        }
        if (tmp_11) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 6, tmp2_cached[6].get_value_j01efc_k$(), value.race_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 7) ? true : !(value.gender_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 7, tmp2_cached[7].get_value_j01efc_k$(), value.gender_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 8) ? true : !(value.birthDate_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 8, LocalDateSerializer_getInstance(), value.birthDate_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_gd4eqp_k$(encoder, value instanceof Parent() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp14_cached = Companion_getInstance_22().$childSerializers_1;
        if (tmp13_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp13_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp13_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp = EmailAddressSerializer_getInstance();
          var tmp_0 = tmp6_local2;
          var tmp_1 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, tmp, tmp_0 == null ? null : new (EmailAddress())(tmp_0));
          tmp6_local2 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp_2 = PhoneNumberSerializer_getInstance();
          var tmp_3 = tmp7_local3;
          var tmp_4 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, tmp_2, tmp_3 == null ? null : new (PhoneNumber())(tmp_3));
          tmp7_local3 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp_5 = PhoneNumberSerializer_getInstance();
          var tmp_6 = tmp8_local4;
          var tmp_7 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, tmp_5, tmp_6 == null ? null : new (PhoneNumber())(tmp_6));
          tmp8_local4 = tmp_7 == null ? null : tmp_7.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp13_input.decodeStringElement_3oenpg_k$(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp13_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp14_cached[6].get_value_j01efc_k$(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 7, tmp14_cached[7].get_value_j01efc_k$(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 8, LocalDateSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp13_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp13_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp13_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_8 = EmailAddressSerializer_getInstance();
                var tmp_9 = tmp6_local2;
                var tmp_10 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, tmp_8, tmp_9 == null ? null : new (EmailAddress())(tmp_9));
                tmp6_local2 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_11 = PhoneNumberSerializer_getInstance();
                var tmp_12 = tmp7_local3;
                var tmp_13 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, tmp_11, tmp_12 == null ? null : new (PhoneNumber())(tmp_12));
                tmp7_local3 = tmp_13 == null ? null : tmp_13.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_14 = PhoneNumberSerializer_getInstance();
                var tmp_15 = tmp8_local4;
                var tmp_16 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, tmp_14, tmp_15 == null ? null : new (PhoneNumber())(tmp_15));
                tmp8_local4 = tmp_16 == null ? null : tmp_16.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp13_input.decodeStringElement_3oenpg_k$(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp13_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp14_cached[6].get_value_j01efc_k$(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 7, tmp14_cached[7].get_value_j01efc_k$(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 8, LocalDateSerializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp13_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Parent().new_org_thecommunitygroupinc_cares_Parent_ylzow2_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_22().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(EmailAddressSerializer_getInstance()), get_nullable(PhoneNumberSerializer_getInstance()), get_nullable(PhoneNumberSerializer_getInstance()), StringSerializer_getInstance(), tmp0_cached[6].get_value_j01efc_k$(), get_nullable(tmp0_cached[7].get_value_j01efc_k$()), get_nullable(LocalDateSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_14 = $;
  }
  return $serializerClass_14;
}
var $serializer_instance_14;
function $serializer_getInstance_25() {
  if ($serializer_instance_14 === VOID)
    new ($serializer_14())();
  return $serializer_instance_14;
}
var ParentClass;
function Parent() {
  if (ParentClass === VOID) {
    class $ {
      constructor(firstName, lastName, email, phone, alternatePhone, preferredLanguage, race, gender, birthDate) {
        Companion_getInstance_22();
        email = email === VOID ? null : email;
        phone = phone === VOID ? null : phone;
        alternatePhone = alternatePhone === VOID ? null : alternatePhone;
        preferredLanguage = preferredLanguage === VOID ? '' : preferredLanguage;
        var tmp;
        if (race === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = race;
        }
        race = tmp;
        gender = gender === VOID ? null : gender;
        birthDate = birthDate === VOID ? null : birthDate;
        this.firstName_1 = firstName;
        this.lastName_1 = lastName;
        this.email_1 = email;
        this.phone_1 = phone;
        this.alternatePhone_1 = alternatePhone;
        this.preferredLanguage_1 = preferredLanguage;
        this.race_1 = race;
        this.gender_1 = gender;
        this.birthDate_1 = birthDate;
      }
      get_fullName_9skygt_k$() {
        return this.firstName_1 + ' ' + this.lastName_1;
      }
      toString() {
        var tmp = this.email_1;
        var tmp_0 = toString_0(tmp == null ? null : new (EmailAddress())(tmp));
        var tmp_1 = this.phone_1;
        var tmp_2 = toString_0(tmp_1 == null ? null : new (PhoneNumber())(tmp_1));
        var tmp_3 = this.alternatePhone_1;
        return 'Parent(firstName=' + this.firstName_1 + ', lastName=' + this.lastName_1 + ', email=' + tmp_0 + ', phone=' + tmp_2 + ', alternatePhone=' + toString_0(tmp_3 == null ? null : new (PhoneNumber())(tmp_3)) + ', preferredLanguage=' + this.preferredLanguage_1 + ', race=' + toString(this.race_1) + ', gender=' + toString_0(this.gender_1) + ', birthDate=' + toString_0(this.birthDate_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.firstName_1);
        result = imul(result, 31) + getStringHashCode(this.lastName_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.email_1;
        if ((tmp_1 == null ? null : new (EmailAddress())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = EmailAddress__hashCode_impl_wizg9y(this.email_1);
        }
        result = tmp + tmp_0 | 0;
        var tmp_2 = imul(result, 31);
        var tmp_3;
        var tmp_4 = this.phone_1;
        if ((tmp_4 == null ? null : new (PhoneNumber())(tmp_4)) == null) {
          tmp_3 = 0;
        } else {
          tmp_3 = PhoneNumber__hashCode_impl_t98twl(this.phone_1);
        }
        result = tmp_2 + tmp_3 | 0;
        var tmp_5 = imul(result, 31);
        var tmp_6;
        var tmp_7 = this.alternatePhone_1;
        if ((tmp_7 == null ? null : new (PhoneNumber())(tmp_7)) == null) {
          tmp_6 = 0;
        } else {
          tmp_6 = PhoneNumber__hashCode_impl_t98twl(this.alternatePhone_1);
        }
        result = tmp_5 + tmp_6 | 0;
        result = imul(result, 31) + getStringHashCode(this.preferredLanguage_1) | 0;
        result = imul(result, 31) + hashCode(this.race_1) | 0;
        result = imul(result, 31) + (this.gender_1 == null ? 0 : this.gender_1.hashCode()) | 0;
        result = imul(result, 31) + (this.birthDate_1 == null ? 0 : this.birthDate_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Parent()))
          return false;
        if (!(this.firstName_1 === other.firstName_1))
          return false;
        if (!(this.lastName_1 === other.lastName_1))
          return false;
        var tmp = this.email_1;
        var tmp_0 = tmp == null ? null : new (EmailAddress())(tmp);
        var tmp_1 = other.email_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (EmailAddress())(tmp_1)))
          return false;
        var tmp_2 = this.phone_1;
        var tmp_3 = tmp_2 == null ? null : new (PhoneNumber())(tmp_2);
        var tmp_4 = other.phone_1;
        if (!equals(tmp_3, tmp_4 == null ? null : new (PhoneNumber())(tmp_4)))
          return false;
        var tmp_5 = this.alternatePhone_1;
        var tmp_6 = tmp_5 == null ? null : new (PhoneNumber())(tmp_5);
        var tmp_7 = other.alternatePhone_1;
        if (!equals(tmp_6, tmp_7 == null ? null : new (PhoneNumber())(tmp_7)))
          return false;
        if (!(this.preferredLanguage_1 === other.preferredLanguage_1))
          return false;
        if (!equals(this.race_1, other.race_1))
          return false;
        if (!equals(this.gender_1, other.gender_1))
          return false;
        if (!equals(this.birthDate_1, other.birthDate_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_Parent_ylzow2_k$(seen0, firstName, lastName, email, phone, alternatePhone, preferredLanguage, race, gender, birthDate, serializationConstructorMarker) {
        Companion_getInstance_22();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_25().descriptor_1);
        }
        var $this = createThis(this);
        $this.firstName_1 = firstName;
        $this.lastName_1 = lastName;
        if (0 === (seen0 & 4))
          $this.email_1 = null;
        else
          $this.email_1 = email;
        if (0 === (seen0 & 8))
          $this.phone_1 = null;
        else
          $this.phone_1 = phone;
        if (0 === (seen0 & 16))
          $this.alternatePhone_1 = null;
        else
          $this.alternatePhone_1 = alternatePhone;
        if (0 === (seen0 & 32))
          $this.preferredLanguage_1 = '';
        else
          $this.preferredLanguage_1 = preferredLanguage;
        if (0 === (seen0 & 64)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.race_1 = emptySet();
        } else
          $this.race_1 = race;
        if (0 === (seen0 & 128))
          $this.gender_1 = null;
        else
          $this.gender_1 = gender;
        if (0 === (seen0 & 256))
          $this.birthDate_1 = null;
        else
          $this.birthDate_1 = birthDate;
        return $this;
      }
    }
    initMetadataForClass($, 'Parent', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_25});
    ParentClass = $;
  }
  return ParentClass;
}
var CompanionClass_18;
function Companion_18() {
  if (CompanionClass_18 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_26();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_18 = $;
  }
  return CompanionClass_18;
}
var Companion_instance_20;
function Companion_getInstance_23() {
  return Companion_instance_20;
}
var $serializerClass_15;
function $serializer_15() {
  if ($serializerClass_15 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_15 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.IncomeRange', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('min', true);
        tmp0_serialDesc.addElement_5pzumi_k$('max', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_7l4ll3_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0)) {
          tmp = true;
        } else {
          var tmp_0 = value.min_1;
          tmp = !((tmp_0 == null ? null : new (Cents())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = $serializer_getInstance_9();
          var tmp_2 = value.min_1;
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, tmp_1, tmp_2 == null ? null : new (Cents())(tmp_2));
        }
        var tmp_3;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1)) {
          tmp_3 = true;
        } else {
          var tmp_4 = value.max_1;
          tmp_3 = !((tmp_4 == null ? null : new (Cents())(tmp_4)) == null);
        }
        if (tmp_3) {
          var tmp_5 = $serializer_getInstance_9();
          var tmp_6 = value.max_1;
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, tmp_5, tmp_6 == null ? null : new (Cents())(tmp_6));
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_7l4ll3_k$(encoder, value instanceof IncomeRange() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_9();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (Cents())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_9();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (Cents())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_5 = $serializer_getInstance_9();
                var tmp_6 = tmp4_local0;
                var tmp_7 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, tmp_5, tmp_6 == null ? null : new (Cents())(tmp_6));
                tmp4_local0 = tmp_7 == null ? null : tmp_7.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_8 = $serializer_getInstance_9();
                var tmp_9 = tmp5_local1;
                var tmp_10 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, tmp_8, tmp_9 == null ? null : new (Cents())(tmp_9));
                tmp5_local1 = tmp_10 == null ? null : tmp_10.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return IncomeRange().new_org_thecommunitygroupinc_cares_IncomeRange_cbr3h6_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable($serializer_getInstance_9()), get_nullable($serializer_getInstance_9())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_15 = $;
  }
  return $serializerClass_15;
}
var $serializer_instance_15;
function $serializer_getInstance_26() {
  if ($serializer_instance_15 === VOID)
    new ($serializer_15())();
  return $serializer_instance_15;
}
var IncomeRangeClass;
function IncomeRange() {
  if (IncomeRangeClass === VOID) {
    class $ {
      constructor(min, max) {
        min = min === VOID ? null : min;
        max = max === VOID ? null : max;
        this.min_1 = min;
        this.max_1 = max;
      }
      toString() {
        var tmp = this.min_1;
        var tmp_0 = toString_0(tmp == null ? null : new (Cents())(tmp));
        var tmp_1 = this.max_1;
        return 'IncomeRange(min=' + tmp_0 + ', max=' + toString_0(tmp_1 == null ? null : new (Cents())(tmp_1)) + ')';
      }
      hashCode() {
        var tmp;
        var tmp_0 = this.min_1;
        if ((tmp_0 == null ? null : new (Cents())(tmp_0)) == null) {
          tmp = 0;
        } else {
          tmp = Cents__hashCode_impl_slsn8n(this.min_1);
        }
        var result = tmp;
        var tmp_1 = imul(result, 31);
        var tmp_2;
        var tmp_3 = this.max_1;
        if ((tmp_3 == null ? null : new (Cents())(tmp_3)) == null) {
          tmp_2 = 0;
        } else {
          tmp_2 = Cents__hashCode_impl_slsn8n(this.max_1);
        }
        result = tmp_1 + tmp_2 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IncomeRange()))
          return false;
        var tmp = this.min_1;
        var tmp_0 = tmp == null ? null : new (Cents())(tmp);
        var tmp_1 = other.min_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (Cents())(tmp_1)))
          return false;
        var tmp_2 = this.max_1;
        var tmp_3 = tmp_2 == null ? null : new (Cents())(tmp_2);
        var tmp_4 = other.max_1;
        if (!equals(tmp_3, tmp_4 == null ? null : new (Cents())(tmp_4)))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_IncomeRange_cbr3h6_k$(seen0, min, max, serializationConstructorMarker) {
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_26().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.min_1 = null;
        else
          $this.min_1 = min;
        if (0 === (seen0 & 2))
          $this.max_1 = null;
        else
          $this.max_1 = max;
        return $this;
      }
    }
    initMetadataForClass($, 'IncomeRange', IncomeRange, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_26});
    IncomeRangeClass = $;
  }
  return IncomeRangeClass;
}
function _ID___init__impl__k1lb7e_5(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_5($this) {
  return $this;
}
function ID__toString_impl_y5caka_6($this) {
  return _ID___get_raw__impl__92g6u5_5($this).toString();
}
var CompanionClass_19;
function Companion_19() {
  if (CompanionClass_19 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_27();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_19 = $;
  }
  return CompanionClass_19;
}
var Companion_instance_21;
function Companion_getInstance_24() {
  return Companion_instance_21;
}
var $serializerClass_16;
function $serializer_16() {
  if ($serializerClass_16 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_16 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.FamilyEmployerAuthorization.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(FamilyEmployerAuthorization())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_oqex2m_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_5(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_oqex2m_k$(encoder, value instanceof ID_6() ? value.raw_1 : THROW_CCE());
      }
      deserialize_1itsob_k$(decoder) {
        return _ID___init__impl__k1lb7e_5(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_6())(this.deserialize_1itsob_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_16 = $;
  }
  return $serializerClass_16;
}
var $serializer_instance_16;
function $serializer_getInstance_27() {
  if ($serializer_instance_16 === VOID)
    new ($serializer_16())();
  return $serializer_instance_16;
}
function ID__hashCode_impl_f4lulz_6($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_5($this, other) {
  if (!(other instanceof ID_6()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_5($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_6())(other instanceof ID_6() ? other.raw_1 : THROW_CCE()));
}
var IDClass_5;
function ID_6() {
  if (IDClass_5 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_5(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_6(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_6(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_5(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_5(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_27});
    IDClass_5 = $;
  }
  return IDClass_5;
}
var CompanionClass_20;
function Companion_20() {
  if (CompanionClass_20 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_28();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_20 = $;
  }
  return CompanionClass_20;
}
var Companion_instance_22;
function Companion_getInstance_25() {
  return Companion_instance_22;
}
var $serializerClass_17;
function $serializer_17() {
  if ($serializerClass_17 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_17 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.FamilyEmployerAuthorization', this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('family', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.addElement_5pzumi_k$('employer', false);
        tmp0_serialDesc.addElement_5pzumi_k$('activeRange', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['employer', 'activeRange.start']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['family', 'employer', 'activeRange.start', 'activeRange.endInclusive']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['-activeRange.start']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_cgi2r1_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_5(Companion_getInstance().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_27(), new (ID_6())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_21(), new (ID_4())(value.family_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance_10(), new (ID_0())(value.employer_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, $serializer_getInstance_2(), value.activeRange_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_cgi2r1_k$(encoder, value instanceof FamilyEmployerAuthorization() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_27();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_6())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_21();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID_4())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_5 = $serializer_getInstance_10();
          var tmp_6 = tmp6_local2;
          var tmp_7 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new (ID_0())(tmp_6));
          tmp6_local2 = tmp_7 == null ? null : tmp_7.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, $serializer_getInstance_2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_8 = $serializer_getInstance_27();
                var tmp_9 = tmp4_local0;
                var tmp_10 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_8, tmp_9 == null ? null : new (ID_6())(tmp_9));
                tmp4_local0 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_11 = $serializer_getInstance_21();
                var tmp_12 = tmp5_local1;
                var tmp_13 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_11, tmp_12 == null ? null : new (ID_4())(tmp_12));
                tmp5_local1 = tmp_13 == null ? null : tmp_13.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_14 = $serializer_getInstance_10();
                var tmp_15 = tmp6_local2;
                var tmp_16 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_14, tmp_15 == null ? null : new (ID_0())(tmp_15));
                tmp6_local2 = tmp_16 == null ? null : tmp_16.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, $serializer_getInstance_2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return FamilyEmployerAuthorization().new_org_thecommunitygroupinc_cares_FamilyEmployerAuthorization_duasj1_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_27(), $serializer_getInstance_21(), $serializer_getInstance_10(), $serializer_getInstance_2()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_17 = $;
  }
  return $serializerClass_17;
}
var $serializer_instance_17;
function $serializer_getInstance_28() {
  if ($serializer_instance_17 === VOID)
    new ($serializer_17())();
  return $serializer_instance_17;
}
var FamilyEmployerAuthorizationClass;
function FamilyEmployerAuthorization() {
  if (FamilyEmployerAuthorizationClass === VOID) {
    class $ {
      constructor(_id, family, employer, activeRange) {
        _id = _id === VOID ? _ID___init__impl__k1lb7e_5(Companion_getInstance().random_fimq0t_k$()) : _id;
        this._id_1 = _id;
        this.family_1 = family;
        this.employer_1 = employer;
        this.activeRange_1 = activeRange;
      }
      get__id_a0i3p4_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_6())(this.get__id_a0i3p4_k$());
      }
      toString() {
        return 'FamilyEmployerAuthorization(_id=' + ID__toString_impl_y5caka_6(this._id_1) + ', family=' + ID__toString_impl_y5caka_4(this.family_1) + ', employer=' + ID__toString_impl_y5caka_0(this.employer_1) + ', activeRange=' + this.activeRange_1.toString() + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_6(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_4(this.family_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_0(this.employer_1) | 0;
        result = imul(result, 31) + this.activeRange_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FamilyEmployerAuthorization()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.family_1, other.family_1))
          return false;
        if (!equals(this.employer_1, other.employer_1))
          return false;
        if (!this.activeRange_1.equals(other.activeRange_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_FamilyEmployerAuthorization_duasj1_k$(seen0, _id, family, employer, activeRange, serializationConstructorMarker) {
        if (!(14 === (14 & seen0))) {
          throwMissingFieldException(seen0, 14, $serializer_getInstance_28().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_5(Companion_getInstance().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.family_1 = family;
        $this.employer_1 = employer;
        $this.activeRange_1 = activeRange;
        return $this;
      }
    }
    initMetadataForClass($, 'FamilyEmployerAuthorization', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_28});
    FamilyEmployerAuthorizationClass = $;
  }
  return FamilyEmployerAuthorizationClass;
}
function _ID___init__impl__k1lb7e_6(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_6($this) {
  return $this;
}
function ID__toString_impl_y5caka_7($this) {
  return _ID___get_raw__impl__92g6u5_6($this).toString();
}
var CompanionClass_21;
function Companion_21() {
  if (CompanionClass_21 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_29();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_21 = $;
  }
  return CompanionClass_21;
}
var Companion_instance_23;
function Companion_getInstance_26() {
  return Companion_instance_23;
}
var $serializerClass_18;
function $serializer_18() {
  if ($serializerClass_18 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_18 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.Child.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(Child())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_3gy2r4_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_6(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_3gy2r4_k$(encoder, value instanceof ID_7() ? value.raw_1 : THROW_CCE());
      }
      deserialize_61d37b_k$(decoder) {
        return _ID___init__impl__k1lb7e_6(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_7())(this.deserialize_61d37b_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_18 = $;
  }
  return $serializerClass_18;
}
var $serializer_instance_18;
function $serializer_getInstance_29() {
  if ($serializer_instance_18 === VOID)
    new ($serializer_18())();
  return $serializer_instance_18;
}
function ID__hashCode_impl_f4lulz_7($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_6($this, other) {
  if (!(other instanceof ID_7()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_6($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_7())(other instanceof ID_7() ? other.raw_1 : THROW_CCE()));
}
function Child$Companion$$childSerializers$_anonymous__sbvjxu() {
  return new (LinkedHashSetSerializer())(Companion_getInstance_0().serializer_9w0wvi_k$());
}
function Child$Companion$$childSerializers$_anonymous__sbvjxu_0() {
  return Companion_getInstance_1().serializer_9w0wvi_k$();
}
var IDClass_6;
function ID_7() {
  if (IDClass_6 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_6(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_7(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_7(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_6(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_6(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_29});
    IDClass_6 = $;
  }
  return IDClass_6;
}
var CompanionClass_22;
function Companion_22() {
  if (CompanionClass_22 === VOID) {
    class $ {
      constructor() {
        Companion_instance_24 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Child$Companion$$childSerializers$_anonymous__sbvjxu);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, null, null, null, tmp_1, lazy(tmp_2, Child$Companion$$childSerializers$_anonymous__sbvjxu_0), null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_30();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_22 = $;
  }
  return CompanionClass_22;
}
var Companion_instance_24;
function Companion_getInstance_27() {
  if (Companion_instance_24 === VOID)
    new (Companion_22())();
  return Companion_instance_24;
}
var $serializerClass_19;
function $serializer_19() {
  if ($serializerClass_19 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_19 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.Child', this, 9);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('family', false);
        tmp0_serialDesc.addElement_5pzumi_k$('firstName', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Group())('childName'));
        tmp0_serialDesc.addElement_5pzumi_k$('lastName', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Group())('childName'));
        tmp0_serialDesc.addElement_5pzumi_k$('birthDate', false);
        tmp0_serialDesc.addElement_5pzumi_k$('notes', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Multiline())());
        tmp0_serialDesc.addElement_5pzumi_k$('race', true);
        tmp0_serialDesc.addElement_5pzumi_k$('gender', true);
        tmp0_serialDesc.addElement_5pzumi_k$('active', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['firstName', 'lastName']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['firstName', 'lastName', 'family', 'birthDate']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['~lastName', '~firstName']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_fkhprp_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_27().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_6(Companion_getInstance().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_29(), new (ID_7())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_21(), new (ID_4())(value.family_1));
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.firstName_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 3, value.lastName_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, LocalDateSerializer_getInstance(), value.birthDate_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.notes_1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 5, value.notes_1);
        }
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp = !equals(value.race_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 6, tmp2_cached[6].get_value_j01efc_k$(), value.race_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 7) ? true : !(value.gender_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 7, tmp2_cached[7].get_value_j01efc_k$(), value.gender_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 8) ? true : !(value.active_1 === true)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 8, value.active_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_fkhprp_k$(encoder, value instanceof Child() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = false;
        var tmp13_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp14_cached = Companion_getInstance_27().$childSerializers_1;
        if (tmp13_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_29();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp13_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_7())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_21();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp13_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID_4())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp13_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp13_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp13_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, LocalDateSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp13_input.decodeStringElement_3oenpg_k$(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp13_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp14_cached[6].get_value_j01efc_k$(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 7, tmp14_cached[7].get_value_j01efc_k$(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp13_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp13_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_5 = $serializer_getInstance_29();
                var tmp_6 = tmp4_local0;
                var tmp_7 = tmp13_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_5, tmp_6 == null ? null : new (ID_7())(tmp_6));
                tmp4_local0 = tmp_7 == null ? null : tmp_7.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_8 = $serializer_getInstance_21();
                var tmp_9 = tmp5_local1;
                var tmp_10 = tmp13_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_8, tmp_9 == null ? null : new (ID_4())(tmp_9));
                tmp5_local1 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp13_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp13_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp13_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, LocalDateSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp13_input.decodeStringElement_3oenpg_k$(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp13_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp14_cached[6].get_value_j01efc_k$(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 7, tmp14_cached[7].get_value_j01efc_k$(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp13_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp13_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Child().new_org_thecommunitygroupinc_cares_Child_kl27c6_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_27().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_29(), $serializer_getInstance_21(), StringSerializer_getInstance(), StringSerializer_getInstance(), LocalDateSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[6].get_value_j01efc_k$(), get_nullable(tmp0_cached[7].get_value_j01efc_k$()), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_19 = $;
  }
  return $serializerClass_19;
}
var $serializer_instance_19;
function $serializer_getInstance_30() {
  if ($serializer_instance_19 === VOID)
    new ($serializer_19())();
  return $serializer_instance_19;
}
var ChildClass;
function Child() {
  if (ChildClass === VOID) {
    class $ {
      constructor(_id, family, firstName, lastName, birthDate, notes, race, gender, active) {
        Companion_getInstance_27();
        _id = _id === VOID ? _ID___init__impl__k1lb7e_6(Companion_getInstance().random_fimq0t_k$()) : _id;
        notes = notes === VOID ? '' : notes;
        var tmp;
        if (race === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = race;
        }
        race = tmp;
        gender = gender === VOID ? null : gender;
        active = active === VOID ? true : active;
        this._id_1 = _id;
        this.family_1 = family;
        this.firstName_1 = firstName;
        this.lastName_1 = lastName;
        this.birthDate_1 = birthDate;
        this.notes_1 = notes;
        this.race_1 = race;
        this.gender_1 = gender;
        this.active_1 = active;
      }
      get__id_p8fz86_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_7())(this.get__id_p8fz86_k$());
      }
      get_fullName_9skygt_k$() {
        return this.firstName_1 + ' ' + this.lastName_1;
      }
      get_ageInMonths_kafbji_k$() {
        // Inline function 'kotlin.let' call
        var it = periodUntil(this.birthDate_1, todayIn(System_instance, Companion_getInstance_3().currentSystemDefault_9rduv_k$()));
        return imul(it.get_years_j1r3xp_k$(), 12) + it.get_months_gqmrjw_k$() | 0;
      }
      copy_8a717o_k$(_id, family, firstName, lastName, birthDate, notes, race, gender, active) {
        return new (Child())(_id, family, firstName, lastName, birthDate, notes, race, gender, active);
      }
      copy$default_n01c7j_k$(_id, family, firstName, lastName, birthDate, notes, race, gender, active, $super) {
        _id = _id === VOID ? this._id_1 : _id;
        family = family === VOID ? this.family_1 : family;
        firstName = firstName === VOID ? this.firstName_1 : firstName;
        lastName = lastName === VOID ? this.lastName_1 : lastName;
        birthDate = birthDate === VOID ? this.birthDate_1 : birthDate;
        notes = notes === VOID ? this.notes_1 : notes;
        race = race === VOID ? this.race_1 : race;
        gender = gender === VOID ? this.gender_1 : gender;
        active = active === VOID ? this.active_1 : active;
        return $super === VOID ? this.copy_8a717o_k$(_id, family, firstName, lastName, birthDate, notes, race, gender, active) : $super.copy_8a717o_k$.call(this, new (ID_7())(_id), new (ID_4())(family), firstName, lastName, birthDate, notes, race, gender, active);
      }
      toString() {
        return 'Child(_id=' + ID__toString_impl_y5caka_7(this._id_1) + ', family=' + ID__toString_impl_y5caka_4(this.family_1) + ', firstName=' + this.firstName_1 + ', lastName=' + this.lastName_1 + ', birthDate=' + this.birthDate_1.toString() + ', notes=' + this.notes_1 + ', race=' + toString(this.race_1) + ', gender=' + toString_0(this.gender_1) + ', active=' + this.active_1 + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_7(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_4(this.family_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.firstName_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.lastName_1) | 0;
        result = imul(result, 31) + this.birthDate_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.notes_1) | 0;
        result = imul(result, 31) + hashCode(this.race_1) | 0;
        result = imul(result, 31) + (this.gender_1 == null ? 0 : this.gender_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.active_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Child()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.family_1, other.family_1))
          return false;
        if (!(this.firstName_1 === other.firstName_1))
          return false;
        if (!(this.lastName_1 === other.lastName_1))
          return false;
        if (!this.birthDate_1.equals(other.birthDate_1))
          return false;
        if (!(this.notes_1 === other.notes_1))
          return false;
        if (!equals(this.race_1, other.race_1))
          return false;
        if (!equals(this.gender_1, other.gender_1))
          return false;
        if (!(this.active_1 === other.active_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_Child_kl27c6_k$(seen0, _id, family, firstName, lastName, birthDate, notes, race, gender, active, serializationConstructorMarker) {
        Companion_getInstance_27();
        if (!(30 === (30 & seen0))) {
          throwMissingFieldException(seen0, 30, $serializer_getInstance_30().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_6(Companion_getInstance().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.family_1 = family;
        $this.firstName_1 = firstName;
        $this.lastName_1 = lastName;
        $this.birthDate_1 = birthDate;
        if (0 === (seen0 & 32))
          $this.notes_1 = '';
        else
          $this.notes_1 = notes;
        if (0 === (seen0 & 64)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.race_1 = emptySet();
        } else
          $this.race_1 = race;
        if (0 === (seen0 & 128))
          $this.gender_1 = null;
        else
          $this.gender_1 = gender;
        if (0 === (seen0 & 256))
          $this.active_1 = true;
        else
          $this.active_1 = active;
        return $this;
      }
    }
    initMetadataForClass($, 'Child', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_30});
    ChildClass = $;
  }
  return ChildClass;
}
function _ID___init__impl__k1lb7e_7(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_7($this) {
  return $this;
}
function ID__toString_impl_y5caka_8($this) {
  return _ID___get_raw__impl__92g6u5_7($this).toString();
}
var CompanionClass_23;
function Companion_23() {
  if (CompanionClass_23 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_31();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_23 = $;
  }
  return CompanionClass_23;
}
var Companion_instance_25;
function Companion_getInstance_28() {
  return Companion_instance_25;
}
var $serializerClass_20;
function $serializer_20() {
  if ($serializerClass_20 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_20 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.ChildAttendance.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(ChildAttendance())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_qflac9_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_7(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_qflac9_k$(encoder, value instanceof ID_8() ? value.raw_1 : THROW_CCE());
      }
      deserialize_tc8xy8_k$(decoder) {
        return _ID___init__impl__k1lb7e_7(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_8())(this.deserialize_tc8xy8_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_20 = $;
  }
  return $serializerClass_20;
}
var $serializer_instance_20;
function $serializer_getInstance_31() {
  if ($serializer_instance_20 === VOID)
    new ($serializer_20())();
  return $serializer_instance_20;
}
function ID__hashCode_impl_f4lulz_8($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_7($this, other) {
  if (!(other instanceof ID_8()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_7($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_8())(other instanceof ID_8() ? other.raw_1 : THROW_CCE()));
}
function ChildAttendance$Companion$$childSerializers$_anonymous__founy3() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_10());
}
function ChildAttendance$Companion$$childSerializers$_anonymous__founy3_0() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_12());
}
var IDClass_7;
function ID_8() {
  if (IDClass_7 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_7(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_8(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_8(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_7(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_7(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_31});
    IDClass_7 = $;
  }
  return IDClass_7;
}
var CompanionClass_24;
function Companion_24() {
  if (CompanionClass_24 === VOID) {
    class $ {
      constructor() {
        Companion_instance_26 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ChildAttendance$Companion$$childSerializers$_anonymous__founy3);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, null, tmp_1, lazy(tmp_2, ChildAttendance$Companion$$childSerializers$_anonymous__founy3_0), null, null, null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_32();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_24 = $;
  }
  return CompanionClass_24;
}
var Companion_instance_26;
function Companion_getInstance_29() {
  if (Companion_instance_26 === VOID)
    new (Companion_24())();
  return Companion_instance_26;
}
var $serializerClass_21;
function $serializer_21() {
  if ($serializerClass_21 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_21 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.ChildAttendance', this, 10);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('placement', false);
        tmp0_serialDesc.addElement_5pzumi_k$('child', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('family', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('employers', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('grants', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('location', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('provider', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('date', false);
        tmp0_serialDesc.addElement_5pzumi_k$('attendance', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (IndexSet())(['placement', 'date'], IndexUniqueness_Unique_getInstance()));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (IndexSet())(['provider', 'date']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (IndexSet())(['location', 'date']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['date', 'attendance.case']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['date', 'child', 'location', 'attendance.case', 'attendance.useIntermittent']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['-date']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_d6ik8u_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_29().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_7(Companion_getInstance().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_31(), new (ID_8())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_16(), new (ID_3())(value.placement_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance_29(), new (ID_7())(value.child_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, $serializer_getInstance_21(), new (ID_4())(value.family_1));
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp = !equals(value.employers_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, tmp2_cached[4].get_value_j01efc_k$(), value.employers_1);
        }
        var tmp_0;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5)) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$1 = emptySet();
          tmp_0 = !equals(value.grants_1, tmp$ret$1);
        }
        if (tmp_0) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, tmp2_cached[5].get_value_j01efc_k$(), value.grants_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 6, $serializer_getInstance_23(), new (ID_5())(value.location_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 7, $serializer_getInstance_14(), new (ID_2())(value.provider_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 8, LocalDateSerializer_getInstance(), value.date_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 9, $serializer_getInstance_8(), value.attendance_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_d6ik8u_k$(encoder, value instanceof ChildAttendance() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp15_cached = Companion_getInstance_29().$childSerializers_1;
        if (tmp14_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_31();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_8())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_16();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID_3())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_5 = $serializer_getInstance_29();
          var tmp_6 = tmp6_local2;
          var tmp_7 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new (ID_7())(tmp_6));
          tmp6_local2 = tmp_7 == null ? null : tmp_7.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp_8 = $serializer_getInstance_21();
          var tmp_9 = tmp7_local3;
          var tmp_10 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp_8, tmp_9 == null ? null : new (ID_4())(tmp_9));
          tmp7_local3 = tmp_10 == null ? null : tmp_10.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp15_cached[4].get_value_j01efc_k$(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp15_cached[5].get_value_j01efc_k$(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          var tmp_11 = $serializer_getInstance_23();
          var tmp_12 = tmp10_local6;
          var tmp_13 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp_11, tmp_12 == null ? null : new (ID_5())(tmp_12));
          tmp10_local6 = tmp_13 == null ? null : tmp_13.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          var tmp_14 = $serializer_getInstance_14();
          var tmp_15 = tmp11_local7;
          var tmp_16 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, tmp_14, tmp_15 == null ? null : new (ID_2())(tmp_15));
          tmp11_local7 = tmp_16 == null ? null : tmp_16.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 8, LocalDateSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 9, $serializer_getInstance_8(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp14_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_17 = $serializer_getInstance_31();
                var tmp_18 = tmp4_local0;
                var tmp_19 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_17, tmp_18 == null ? null : new (ID_8())(tmp_18));
                tmp4_local0 = tmp_19 == null ? null : tmp_19.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_20 = $serializer_getInstance_16();
                var tmp_21 = tmp5_local1;
                var tmp_22 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_20, tmp_21 == null ? null : new (ID_3())(tmp_21));
                tmp5_local1 = tmp_22 == null ? null : tmp_22.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_23 = $serializer_getInstance_29();
                var tmp_24 = tmp6_local2;
                var tmp_25 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_23, tmp_24 == null ? null : new (ID_7())(tmp_24));
                tmp6_local2 = tmp_25 == null ? null : tmp_25.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_26 = $serializer_getInstance_21();
                var tmp_27 = tmp7_local3;
                var tmp_28 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp_26, tmp_27 == null ? null : new (ID_4())(tmp_27));
                tmp7_local3 = tmp_28 == null ? null : tmp_28.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp15_cached[4].get_value_j01efc_k$(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp15_cached[5].get_value_j01efc_k$(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                var tmp_29 = $serializer_getInstance_23();
                var tmp_30 = tmp10_local6;
                var tmp_31 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp_29, tmp_30 == null ? null : new (ID_5())(tmp_30));
                tmp10_local6 = tmp_31 == null ? null : tmp_31.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                var tmp_32 = $serializer_getInstance_14();
                var tmp_33 = tmp11_local7;
                var tmp_34 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, tmp_32, tmp_33 == null ? null : new (ID_2())(tmp_33));
                tmp11_local7 = tmp_34 == null ? null : tmp_34.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 8, LocalDateSerializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 9, $serializer_getInstance_8(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp14_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ChildAttendance().new_org_thecommunitygroupinc_cares_ChildAttendance_5dsqpx_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_29().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_31(), $serializer_getInstance_16(), $serializer_getInstance_29(), $serializer_getInstance_21(), tmp0_cached[4].get_value_j01efc_k$(), tmp0_cached[5].get_value_j01efc_k$(), $serializer_getInstance_23(), $serializer_getInstance_14(), LocalDateSerializer_getInstance(), $serializer_getInstance_8()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_21 = $;
  }
  return $serializerClass_21;
}
var $serializer_instance_21;
function $serializer_getInstance_32() {
  if ($serializer_instance_21 === VOID)
    new ($serializer_21())();
  return $serializer_instance_21;
}
var ChildAttendanceClass;
function ChildAttendance() {
  if (ChildAttendanceClass === VOID) {
    class $ {
      constructor(_id, placement, child, family, employers, grants, location, provider, date, attendance) {
        Companion_getInstance_29();
        _id = _id === VOID ? _ID___init__impl__k1lb7e_7(Companion_getInstance().random_fimq0t_k$()) : _id;
        var tmp;
        if (employers === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = employers;
        }
        employers = tmp;
        var tmp_0;
        if (grants === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_0 = emptySet();
        } else {
          tmp_0 = grants;
        }
        grants = tmp_0;
        this._id_1 = _id;
        this.placement_1 = placement;
        this.child_1 = child;
        this.family_1 = family;
        this.employers_1 = employers;
        this.grants_1 = grants;
        this.location_1 = location;
        this.provider_1 = provider;
        this.date_1 = date;
        this.attendance_1 = attendance;
      }
      get__id_ydatd9_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_8())(this.get__id_ydatd9_k$());
      }
      toString() {
        return 'ChildAttendance(_id=' + ID__toString_impl_y5caka_8(this._id_1) + ', placement=' + ID__toString_impl_y5caka_3(this.placement_1) + ', child=' + ID__toString_impl_y5caka_7(this.child_1) + ', family=' + ID__toString_impl_y5caka_4(this.family_1) + ', employers=' + toString(this.employers_1) + ', grants=' + toString(this.grants_1) + ', location=' + ID__toString_impl_y5caka_5(this.location_1) + ', provider=' + ID__toString_impl_y5caka_2(this.provider_1) + ', date=' + this.date_1.toString() + ', attendance=' + this.attendance_1.toString() + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_8(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_3(this.placement_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_7(this.child_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_4(this.family_1) | 0;
        result = imul(result, 31) + hashCode(this.employers_1) | 0;
        result = imul(result, 31) + hashCode(this.grants_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_5(this.location_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_2(this.provider_1) | 0;
        result = imul(result, 31) + this.date_1.hashCode() | 0;
        result = imul(result, 31) + this.attendance_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ChildAttendance()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.placement_1, other.placement_1))
          return false;
        if (!equals(this.child_1, other.child_1))
          return false;
        if (!equals(this.family_1, other.family_1))
          return false;
        if (!equals(this.employers_1, other.employers_1))
          return false;
        if (!equals(this.grants_1, other.grants_1))
          return false;
        if (!equals(this.location_1, other.location_1))
          return false;
        if (!equals(this.provider_1, other.provider_1))
          return false;
        if (!this.date_1.equals(other.date_1))
          return false;
        if (!this.attendance_1.equals(other.attendance_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_ChildAttendance_5dsqpx_k$(seen0, _id, placement, child, family, employers, grants, location, provider, date, attendance, serializationConstructorMarker) {
        Companion_getInstance_29();
        if (!(974 === (974 & seen0))) {
          throwMissingFieldException(seen0, 974, $serializer_getInstance_32().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_7(Companion_getInstance().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.placement_1 = placement;
        $this.child_1 = child;
        $this.family_1 = family;
        if (0 === (seen0 & 16)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.employers_1 = emptySet();
        } else
          $this.employers_1 = employers;
        if (0 === (seen0 & 32)) {
          var tmp_0 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_0.grants_1 = emptySet();
        } else
          $this.grants_1 = grants;
        $this.location_1 = location;
        $this.provider_1 = provider;
        $this.date_1 = date;
        $this.attendance_1 = attendance;
        return $this;
      }
    }
    initMetadataForClass($, 'ChildAttendance', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_32});
    ChildAttendanceClass = $;
  }
  return ChildAttendanceClass;
}
function _ID___init__impl__k1lb7e_8(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_8($this) {
  return $this;
}
function ID__toString_impl_y5caka_9($this) {
  return _ID___get_raw__impl__92g6u5_8($this).toString();
}
var CompanionClass_25;
function Companion_25() {
  if (CompanionClass_25 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_33();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_25 = $;
  }
  return CompanionClass_25;
}
var Companion_instance_27;
function Companion_getInstance_30() {
  return Companion_instance_27;
}
var $serializerClass_22;
function $serializer_22() {
  if ($serializerClass_22 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_22 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.CareLocationClosure.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(CareLocationClosure())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_9a9gd3_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_8(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_9a9gd3_k$(encoder, value instanceof ID_9() ? value.raw_1 : THROW_CCE());
      }
      deserialize_a6bh5c_k$(decoder) {
        return _ID___init__impl__k1lb7e_8(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_9())(this.deserialize_a6bh5c_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_22 = $;
  }
  return $serializerClass_22;
}
var $serializer_instance_22;
function $serializer_getInstance_33() {
  if ($serializer_instance_22 === VOID)
    new ($serializer_22())();
  return $serializer_instance_22;
}
function ID__hashCode_impl_f4lulz_9($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_8($this, other) {
  if (!(other instanceof ID_9()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_8($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_9())(other instanceof ID_9() ? other.raw_1 : THROW_CCE()));
}
function CareLocationClosure$Companion$$childSerializers$_anonymous__jd3qph() {
  return Companion_getInstance_32().serializer_9w0wvi_k$();
}
var IDClass_8;
function ID_9() {
  if (IDClass_8 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_8(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_9(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_9(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_8(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_8(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_33});
    IDClass_8 = $;
  }
  return IDClass_8;
}
var CompanionClass_26;
function Companion_26() {
  if (CompanionClass_26 === VOID) {
    class $ {
      constructor() {
        Companion_instance_28 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, null, lazy(tmp_0, CareLocationClosure$Companion$$childSerializers$_anonymous__jd3qph), null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_34();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_26 = $;
  }
  return CompanionClass_26;
}
var Companion_instance_28;
function Companion_getInstance_31() {
  if (Companion_instance_28 === VOID)
    new (Companion_26())();
  return Companion_instance_28;
}
var $serializerClass_23;
function $serializer_23() {
  if ($serializerClass_23 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_23 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.CareLocationClosure', this, 6);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('provider', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('location', false);
        tmp0_serialDesc.addElement_5pzumi_k$('date', false);
        tmp0_serialDesc.addElement_5pzumi_k$('reason', false);
        tmp0_serialDesc.addElement_5pzumi_k$('submitted', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (IndexSet())(['location', 'date'], IndexUniqueness_Unique_getInstance()));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (IndexSet())(['provider', 'date']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['date']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['date', 'location', 'reason']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['-date']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_w4907i_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_31().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_8(Companion_getInstance().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_33(), new (ID_9())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_14(), new (ID_2())(value.provider_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance_23(), new (ID_5())(value.location_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, LocalDateSerializer_getInstance(), value.date_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, tmp2_cached[4].get_value_j01efc_k$(), value.reason_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !value.submitted_1.equals(Companion_getInstance_2().Placeholder_1)) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, $serializer_getInstance_3(), value.submitted_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_w4907i_k$(encoder, value instanceof CareLocationClosure() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp11_cached = Companion_getInstance_31().$childSerializers_1;
        if (tmp10_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_33();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_9())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_14();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID_2())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_5 = $serializer_getInstance_23();
          var tmp_6 = tmp6_local2;
          var tmp_7 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new (ID_5())(tmp_6));
          tmp6_local2 = tmp_7 == null ? null : tmp_7.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, LocalDateSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp11_cached[4].get_value_j01efc_k$(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, $serializer_getInstance_3(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_8 = $serializer_getInstance_33();
                var tmp_9 = tmp4_local0;
                var tmp_10 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_8, tmp_9 == null ? null : new (ID_9())(tmp_9));
                tmp4_local0 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_11 = $serializer_getInstance_14();
                var tmp_12 = tmp5_local1;
                var tmp_13 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_11, tmp_12 == null ? null : new (ID_2())(tmp_12));
                tmp5_local1 = tmp_13 == null ? null : tmp_13.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_14 = $serializer_getInstance_23();
                var tmp_15 = tmp6_local2;
                var tmp_16 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_14, tmp_15 == null ? null : new (ID_5())(tmp_15));
                tmp6_local2 = tmp_16 == null ? null : tmp_16.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, LocalDateSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp11_cached[4].get_value_j01efc_k$(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, $serializer_getInstance_3(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp10_input.endStructure_1xqz0n_k$(tmp0_desc);
        return CareLocationClosure().new_org_thecommunitygroupinc_cares_CareLocationClosure_3yi84d_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_31().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_33(), $serializer_getInstance_14(), $serializer_getInstance_23(), LocalDateSerializer_getInstance(), tmp0_cached[4].get_value_j01efc_k$(), $serializer_getInstance_3()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_23 = $;
  }
  return $serializerClass_23;
}
var $serializer_instance_23;
function $serializer_getInstance_34() {
  if ($serializer_instance_23 === VOID)
    new ($serializer_23())();
  return $serializer_instance_23;
}
var CareLocationClosureClass;
function CareLocationClosure() {
  if (CareLocationClosureClass === VOID) {
    class $ {
      constructor(_id, provider, location, date, reason, submitted) {
        Companion_getInstance_31();
        _id = _id === VOID ? _ID___init__impl__k1lb7e_8(Companion_getInstance().random_fimq0t_k$()) : _id;
        submitted = submitted === VOID ? Companion_getInstance_2().Placeholder_1 : submitted;
        this._id_1 = _id;
        this.provider_1 = provider;
        this.location_1 = location;
        this.date_1 = date;
        this.reason_1 = reason;
        this.submitted_1 = submitted;
      }
      get__id_y3jjod_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_9())(this.get__id_y3jjod_k$());
      }
      toString() {
        return 'CareLocationClosure(_id=' + ID__toString_impl_y5caka_9(this._id_1) + ', provider=' + ID__toString_impl_y5caka_2(this.provider_1) + ', location=' + ID__toString_impl_y5caka_5(this.location_1) + ', date=' + this.date_1.toString() + ', reason=' + toString(this.reason_1) + ', submitted=' + this.submitted_1.toString() + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_9(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_2(this.provider_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_5(this.location_1) | 0;
        result = imul(result, 31) + this.date_1.hashCode() | 0;
        result = imul(result, 31) + this.reason_1.hashCode() | 0;
        result = imul(result, 31) + this.submitted_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CareLocationClosure()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.provider_1, other.provider_1))
          return false;
        if (!equals(this.location_1, other.location_1))
          return false;
        if (!this.date_1.equals(other.date_1))
          return false;
        if (!this.reason_1.equals(other.reason_1))
          return false;
        if (!this.submitted_1.equals(other.submitted_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_CareLocationClosure_3yi84d_k$(seen0, _id, provider, location, date, reason, submitted, serializationConstructorMarker) {
        Companion_getInstance_31();
        if (!(30 === (30 & seen0))) {
          throwMissingFieldException(seen0, 30, $serializer_getInstance_34().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_8(Companion_getInstance().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.provider_1 = provider;
        $this.location_1 = location;
        $this.date_1 = date;
        $this.reason_1 = reason;
        if (0 === (seen0 & 32))
          $this.submitted_1 = Companion_getInstance_2().Placeholder_1;
        else
          $this.submitted_1 = submitted;
        return $this;
      }
    }
    initMetadataForClass($, 'CareLocationClosure', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_34});
    CareLocationClosureClass = $;
  }
  return CareLocationClosureClass;
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function ClosureReason$Companion$_anonymous__tfc1n4() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.ClosureReason', values_2());
}
var static_init_called_2;
function static_init_2() {
  if (static_init_called_2)
    return Unit_instance;
  static_init_called_2 = true;
  ClosureReason_Holiday_instance = new (ClosureReason())('Holiday', 0, 'Holiday', true);
  ClosureReason_Flexible_instance = new (ClosureReason())('Flexible', 1, 'Flexible', true);
  ClosureReason_ProfessionalDevelopment_instance = new (ClosureReason())('ProfessionalDevelopment', 2, 'Professional Development', true);
  ClosureReason_Emergency_instance = new (ClosureReason())('Emergency', 3, 'Emergency', true);
  ClosureReason_Unapproved_instance = new (ClosureReason())('Unapproved', 4, 'Unapproved', false);
  if (Companion_instance_29 === VOID) {
    Companion_instance;
    new (Companion_27())();
  }
}
var ClosureReason_Holiday_instance;
var ClosureReason_Flexible_instance;
var ClosureReason_ProfessionalDevelopment_instance;
var ClosureReason_Emergency_instance;
var ClosureReason_Unapproved_instance;
var CompanionClass_27;
function Companion_27() {
  if (CompanionClass_27 === VOID) {
    class $ {
      constructor() {
        Companion_instance_29 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, ClosureReason$Companion$_anonymous__tfc1n4);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj_1(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_27 = $;
  }
  return CompanionClass_27;
}
var Companion_instance_29;
function Companion_getInstance_32() {
  static_init_2();
  return Companion_instance_29;
}
function values_2() {
  static_init_2();
  return [ClosureReason_Holiday_getInstance(), ClosureReason_Flexible_getInstance(), ClosureReason_ProfessionalDevelopment_getInstance(), ClosureReason_Emergency_getInstance(), ClosureReason_Unapproved_getInstance()];
}
function get_entries_3() {
  static_init_2();
  if ($ENTRIES_2 == null)
    $ENTRIES_2 = enumEntries(values_2());
  return $ENTRIES_2;
}
var $ENTRIES_2;
var ClosureReasonClass;
function ClosureReason() {
  if (ClosureReasonClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName, paid) {
        super(name, ordinal);
        this.displayName_1 = displayName;
        this.paid_1 = paid;
      }
    }
    initMetadataForClass($, 'ClosureReason', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_32});
    ClosureReasonClass = $;
  }
  return ClosureReasonClass;
}
function _ID___init__impl__k1lb7e_9(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_9($this) {
  return $this;
}
function ID__toString_impl_y5caka_10($this) {
  return _ID___get_raw__impl__92g6u5_9($this).toString();
}
var CompanionClass_28;
function Companion_28() {
  if (CompanionClass_28 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_35();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_28 = $;
  }
  return CompanionClass_28;
}
var Companion_instance_30;
function Companion_getInstance_33() {
  return Companion_instance_30;
}
var $serializerClass_24;
function $serializer_24() {
  if ($serializerClass_24 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_24 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.LocationAttendancePeriod.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(LocationAttendancePeriod())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_w9xsgt_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_9(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_w9xsgt_k$(encoder, value instanceof ID_10() ? value.raw_1 : THROW_CCE());
      }
      deserialize_3xrpea_k$(decoder) {
        return _ID___init__impl__k1lb7e_9(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_10())(this.deserialize_3xrpea_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_24 = $;
  }
  return $serializerClass_24;
}
var $serializer_instance_24;
function $serializer_getInstance_35() {
  if ($serializer_instance_24 === VOID)
    new ($serializer_24())();
  return $serializer_instance_24;
}
function ID__hashCode_impl_f4lulz_10($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_9($this, other) {
  if (!(other instanceof ID_10()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_9($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_10())(other instanceof ID_10() ? other.raw_1 : THROW_CCE()));
}
var IDClass_9;
function ID_10() {
  if (IDClass_9 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_9(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_10(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_10(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_9(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_9(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_35});
    IDClass_9 = $;
  }
  return IDClass_9;
}
var CompanionClass_29;
function Companion_29() {
  if (CompanionClass_29 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_36();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_29 = $;
  }
  return CompanionClass_29;
}
var Companion_instance_31;
function Companion_getInstance_34() {
  return Companion_instance_31;
}
var $serializerClass_25;
function $serializer_25() {
  if ($serializerClass_25 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_25 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.LocationAttendancePeriod', this, 6);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('location', false);
        tmp0_serialDesc.addElement_5pzumi_k$('provider', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('period', false);
        tmp0_serialDesc.addElement_5pzumi_k$('submitted', true);
        tmp0_serialDesc.addElement_5pzumi_k$('approved', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (IndexSet())(['location', 'period'], IndexUniqueness_Unique_getInstance()));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['period.start']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['period.start', 'period.endInclusive', 'location', 'submitted', 'approved']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['-period.start']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_w2tu9k_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_9(Companion_getInstance().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_35(), new (ID_10())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_23(), new (ID_5())(value.location_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance_14(), new (ID_2())(value.provider_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, $serializer_getInstance_2(), value.period_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.submitted_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, $serializer_getInstance_3(), value.submitted_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.approved_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, $serializer_getInstance_3(), value.approved_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_w2tu9k_k$(encoder, value instanceof LocationAttendancePeriod() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp10_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_35();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_10())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_23();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID_5())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_5 = $serializer_getInstance_14();
          var tmp_6 = tmp6_local2;
          var tmp_7 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new (ID_2())(tmp_6));
          tmp6_local2 = tmp_7 == null ? null : tmp_7.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, $serializer_getInstance_2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp10_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, $serializer_getInstance_3(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp10_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, $serializer_getInstance_3(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_8 = $serializer_getInstance_35();
                var tmp_9 = tmp4_local0;
                var tmp_10 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_8, tmp_9 == null ? null : new (ID_10())(tmp_9));
                tmp4_local0 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_11 = $serializer_getInstance_23();
                var tmp_12 = tmp5_local1;
                var tmp_13 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_11, tmp_12 == null ? null : new (ID_5())(tmp_12));
                tmp5_local1 = tmp_13 == null ? null : tmp_13.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_14 = $serializer_getInstance_14();
                var tmp_15 = tmp6_local2;
                var tmp_16 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_14, tmp_15 == null ? null : new (ID_2())(tmp_15));
                tmp6_local2 = tmp_16 == null ? null : tmp_16.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, $serializer_getInstance_2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp10_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, $serializer_getInstance_3(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp10_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, $serializer_getInstance_3(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp10_input.endStructure_1xqz0n_k$(tmp0_desc);
        return LocationAttendancePeriod().new_org_thecommunitygroupinc_cares_LocationAttendancePeriod_ldto7i_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_35(), $serializer_getInstance_23(), $serializer_getInstance_14(), $serializer_getInstance_2(), get_nullable($serializer_getInstance_3()), get_nullable($serializer_getInstance_3())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_25 = $;
  }
  return $serializerClass_25;
}
var $serializer_instance_25;
function $serializer_getInstance_36() {
  if ($serializer_instance_25 === VOID)
    new ($serializer_25())();
  return $serializer_instance_25;
}
var LocationAttendancePeriodClass;
function LocationAttendancePeriod() {
  if (LocationAttendancePeriodClass === VOID) {
    class $ {
      constructor(_id, location, provider, period, submitted, approved) {
        _id = _id === VOID ? _ID___init__impl__k1lb7e_9(Companion_getInstance().random_fimq0t_k$()) : _id;
        submitted = submitted === VOID ? null : submitted;
        approved = approved === VOID ? null : approved;
        this._id_1 = _id;
        this.location_1 = location;
        this.provider_1 = provider;
        this.period_1 = period;
        this.submitted_1 = submitted;
        this.approved_1 = approved;
      }
      get__id_ew330f_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_10())(this.get__id_ew330f_k$());
      }
      get_status_jnf6d7_k$() {
        return this.submitted_1 == null ? 'Not submitted' : this.approved_1 == null ? 'Submitted, needs approval' : '';
      }
      toString() {
        return 'LocationAttendancePeriod(_id=' + ID__toString_impl_y5caka_10(this._id_1) + ', location=' + ID__toString_impl_y5caka_5(this.location_1) + ', provider=' + ID__toString_impl_y5caka_2(this.provider_1) + ', period=' + this.period_1.toString() + ', submitted=' + toString_0(this.submitted_1) + ', approved=' + toString_0(this.approved_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_10(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_5(this.location_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_2(this.provider_1) | 0;
        result = imul(result, 31) + this.period_1.hashCode() | 0;
        result = imul(result, 31) + (this.submitted_1 == null ? 0 : this.submitted_1.hashCode()) | 0;
        result = imul(result, 31) + (this.approved_1 == null ? 0 : this.approved_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LocationAttendancePeriod()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.location_1, other.location_1))
          return false;
        if (!equals(this.provider_1, other.provider_1))
          return false;
        if (!this.period_1.equals(other.period_1))
          return false;
        if (!equals(this.submitted_1, other.submitted_1))
          return false;
        if (!equals(this.approved_1, other.approved_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_LocationAttendancePeriod_ldto7i_k$(seen0, _id, location, provider, period, submitted, approved, serializationConstructorMarker) {
        if (!(14 === (14 & seen0))) {
          throwMissingFieldException(seen0, 14, $serializer_getInstance_36().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_9(Companion_getInstance().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.location_1 = location;
        $this.provider_1 = provider;
        $this.period_1 = period;
        if (0 === (seen0 & 16))
          $this.submitted_1 = null;
        else
          $this.submitted_1 = submitted;
        if (0 === (seen0 & 32))
          $this.approved_1 = null;
        else
          $this.approved_1 = approved;
        return $this;
      }
    }
    initMetadataForClass($, 'LocationAttendancePeriod', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_36});
    LocationAttendancePeriodClass = $;
  }
  return LocationAttendancePeriodClass;
}
function _get_$cachedSerializer__te6jhj_2($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function IncomeOptions$Companion$_anonymous__58aq06() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.IncomeOptions', values_3());
}
var static_init_called_3;
function static_init_3() {
  if (static_init_called_3)
    return Unit_instance;
  static_init_called_3 = true;
  IncomeOptions_Under25k_instance = new (IncomeOptions())('Under25k', 0, 'Under $25,000', Companion_instance_0.get_dollars_6ygubx_k$(0), Companion_instance_0.get_dollars_6ygubx_k$(24999));
  IncomeOptions_Range25kTo49k_instance = new (IncomeOptions())('Range25kTo49k', 1, '$25,000 \u2013 $49,999', Companion_instance_0.get_dollars_6ygubx_k$(25000), Companion_instance_0.get_dollars_6ygubx_k$(49999));
  IncomeOptions_Range50kTo74k_instance = new (IncomeOptions())('Range50kTo74k', 2, '$50,000 \u2013 $74,999', Companion_instance_0.get_dollars_6ygubx_k$(50000), Companion_instance_0.get_dollars_6ygubx_k$(74999));
  IncomeOptions_Range75kTo99k_instance = new (IncomeOptions())('Range75kTo99k', 3, '$75,000 \u2013 $99,999', Companion_instance_0.get_dollars_6ygubx_k$(75000), Companion_instance_0.get_dollars_6ygubx_k$(99999));
  IncomeOptions_Range100kTo149k_instance = new (IncomeOptions())('Range100kTo149k', 4, '$100,000 \u2013 $149,999', Companion_instance_0.get_dollars_6ygubx_k$(100000), Companion_instance_0.get_dollars_6ygubx_k$(149999));
  IncomeOptions_Range150kTo199k_instance = new (IncomeOptions())('Range150kTo199k', 5, '$150,000 \u2013 $199,999', Companion_instance_0.get_dollars_6ygubx_k$(150000), Companion_instance_0.get_dollars_6ygubx_k$(199999));
  IncomeOptions_Range200kPlus_instance = new (IncomeOptions())('Range200kPlus', 6, '$200,000 or more', Companion_instance_0.get_dollars_6ygubx_k$(200000), null);
  if (Companion_instance_32 === VOID) {
    Companion_instance;
    new (Companion_30())();
  }
}
var IncomeOptions_Under25k_instance;
var IncomeOptions_Range25kTo49k_instance;
var IncomeOptions_Range50kTo74k_instance;
var IncomeOptions_Range75kTo99k_instance;
var IncomeOptions_Range100kTo149k_instance;
var IncomeOptions_Range150kTo199k_instance;
var IncomeOptions_Range200kPlus_instance;
var CompanionClass_30;
function Companion_30() {
  if (CompanionClass_30 === VOID) {
    class $ {
      constructor() {
        Companion_instance_32 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, IncomeOptions$Companion$_anonymous__58aq06);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj_2(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_30 = $;
  }
  return CompanionClass_30;
}
var Companion_instance_32;
function Companion_getInstance_35() {
  static_init_3();
  return Companion_instance_32;
}
function values_3() {
  static_init_3();
  return [IncomeOptions_Under25k_getInstance(), IncomeOptions_Range25kTo49k_getInstance(), IncomeOptions_Range50kTo74k_getInstance(), IncomeOptions_Range75kTo99k_getInstance(), IncomeOptions_Range100kTo149k_getInstance(), IncomeOptions_Range150kTo199k_getInstance(), IncomeOptions_Range200kPlus_getInstance()];
}
function get_entries_4() {
  static_init_3();
  if ($ENTRIES_3 == null)
    $ENTRIES_3 = enumEntries(values_3());
  return $ENTRIES_3;
}
var $ENTRIES_3;
var IncomeOptionsClass;
function IncomeOptions() {
  if (IncomeOptionsClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName, min, max) {
        super(name, ordinal);
        this.displayName_1 = displayName;
        this.min_1 = min;
        this.max_1 = max;
      }
    }
    initMetadataForClass($, 'IncomeOptions', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_35});
    IncomeOptionsClass = $;
  }
  return IncomeOptionsClass;
}
function _get_$cachedSerializer__te6jhj_3($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function LeadershipLevel$Companion$_anonymous__2vrg6o() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.LeadershipLevel', values_4());
}
var static_init_called_4;
function static_init_4() {
  if (static_init_called_4)
    return Unit_instance;
  static_init_called_4 = true;
  LeadershipLevel_ManagesNoOne_instance = new (LeadershipLevel())('ManagesNoOne', 0);
  LeadershipLevel_ManagesEmployees_instance = new (LeadershipLevel())('ManagesEmployees', 1);
  LeadershipLevel_ManagesManagers_instance = new (LeadershipLevel())('ManagesManagers', 2);
  LeadershipLevel_SeniorLeader_instance = new (LeadershipLevel())('SeniorLeader', 3);
  if (Companion_instance_33 === VOID) {
    Companion_instance;
    new (Companion_31())();
  }
}
var LeadershipLevel_ManagesNoOne_instance;
var LeadershipLevel_ManagesEmployees_instance;
var LeadershipLevel_ManagesManagers_instance;
var LeadershipLevel_SeniorLeader_instance;
function values_4() {
  static_init_4();
  return [LeadershipLevel_ManagesNoOne_getInstance(), LeadershipLevel_ManagesEmployees_getInstance(), LeadershipLevel_ManagesManagers_getInstance(), LeadershipLevel_SeniorLeader_getInstance()];
}
function get_entries_5() {
  static_init_4();
  if ($ENTRIES_4 == null)
    $ENTRIES_4 = enumEntries(values_4());
  return $ENTRIES_4;
}
var CompanionClass_31;
function Companion_31() {
  if (CompanionClass_31 === VOID) {
    class $ {
      constructor() {
        Companion_instance_33 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, LeadershipLevel$Companion$_anonymous__2vrg6o);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj_3(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_31 = $;
  }
  return CompanionClass_31;
}
var Companion_instance_33;
function Companion_getInstance_36() {
  static_init_4();
  return Companion_instance_33;
}
var $ENTRIES_4;
var LeadershipLevelClass;
function LeadershipLevel() {
  if (LeadershipLevelClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'LeadershipLevel', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_36});
    LeadershipLevelClass = $;
  }
  return LeadershipLevelClass;
}
function AgeGroup_Infant_getInstance() {
  static_init();
  return AgeGroup_Infant_instance;
}
function AgeGroup_Toddler_getInstance() {
  static_init();
  return AgeGroup_Toddler_instance;
}
function AgeGroup_Preschool_getInstance() {
  static_init();
  return AgeGroup_Preschool_instance;
}
function AgeGroup_SchoolAge_getInstance() {
  static_init();
  return AgeGroup_SchoolAge_instance;
}
function CareLocationType_Center_getInstance() {
  static_init_0();
  return CareLocationType_Center_instance;
}
function CareLocationType_FamilyChildCare_getInstance() {
  static_init_0();
  return CareLocationType_FamilyChildCare_instance;
}
function CareLocationType_SystemFamilyChildCare_getInstance() {
  static_init_0();
  return CareLocationType_SystemFamilyChildCare_instance;
}
function ClosureReason_Holiday_getInstance() {
  static_init_2();
  return ClosureReason_Holiday_instance;
}
function ClosureReason_Flexible_getInstance() {
  static_init_2();
  return ClosureReason_Flexible_instance;
}
function ClosureReason_ProfessionalDevelopment_getInstance() {
  static_init_2();
  return ClosureReason_ProfessionalDevelopment_instance;
}
function ClosureReason_Emergency_getInstance() {
  static_init_2();
  return ClosureReason_Emergency_instance;
}
function ClosureReason_Unapproved_getInstance() {
  static_init_2();
  return ClosureReason_Unapproved_instance;
}
function IncomeOptions_Under25k_getInstance() {
  static_init_3();
  return IncomeOptions_Under25k_instance;
}
function IncomeOptions_Range25kTo49k_getInstance() {
  static_init_3();
  return IncomeOptions_Range25kTo49k_instance;
}
function IncomeOptions_Range50kTo74k_getInstance() {
  static_init_3();
  return IncomeOptions_Range50kTo74k_instance;
}
function IncomeOptions_Range75kTo99k_getInstance() {
  static_init_3();
  return IncomeOptions_Range75kTo99k_instance;
}
function IncomeOptions_Range100kTo149k_getInstance() {
  static_init_3();
  return IncomeOptions_Range100kTo149k_instance;
}
function IncomeOptions_Range150kTo199k_getInstance() {
  static_init_3();
  return IncomeOptions_Range150kTo199k_instance;
}
function IncomeOptions_Range200kPlus_getInstance() {
  static_init_3();
  return IncomeOptions_Range200kPlus_instance;
}
function LeadershipLevel_ManagesNoOne_getInstance() {
  static_init_4();
  return LeadershipLevel_ManagesNoOne_instance;
}
function LeadershipLevel_ManagesEmployees_getInstance() {
  static_init_4();
  return LeadershipLevel_ManagesEmployees_instance;
}
function LeadershipLevel_ManagesManagers_getInstance() {
  static_init_4();
  return LeadershipLevel_ManagesManagers_instance;
}
function LeadershipLevel_SeniorLeader_getInstance() {
  static_init_4();
  return LeadershipLevel_SeniorLeader_instance;
}
//region block: init
Companion_instance_1 = new (Companion())();
Companion_instance_2 = new (Companion_0())();
Companion_instance_3 = new (Companion_1())();
Companion_instance_4 = new (Companion_2())();
Companion_instance_5 = new (Companion_3())();
Companion_instance_7 = new (Companion_5())();
Companion_instance_8 = new (Companion_6())();
Companion_instance_9 = new (Companion_7())();
Companion_instance_11 = new (Companion_9())();
Companion_instance_12 = new (Companion_10())();
Companion_instance_13 = new (Companion_11())();
Companion_instance_15 = new (Companion_13())();
Companion_instance_17 = new (Companion_15())();
Companion_instance_20 = new (Companion_18())();
Companion_instance_21 = new (Companion_19())();
Companion_instance_22 = new (Companion_20())();
Companion_instance_23 = new (Companion_21())();
Companion_instance_25 = new (Companion_23())();
Companion_instance_27 = new (Companion_25())();
Companion_instance_30 = new (Companion_28())();
Companion_instance_31 = new (Companion_29())();
//endregion
//region block: exports
export {
  ID__hashCode_impl_f4lulz_5 as ID__hashCode_impl_f4lulz3s4hpwy6rxg06,
  ID__toString_impl_y5caka_5 as ID__toString_impl_y5caka34b933o3jkvt9,
  _ID___init__impl__k1lb7e_1 as _ID___init__impl__k1lb7e1lquexfyufrn6,
  ID__hashCode_impl_f4lulz_2 as ID__hashCode_impl_f4lulz1y71t598eu6qn,
  _ID___get_raw__impl__92g6u5_1 as _ID___get_raw__impl__92g6u53scm0g2ugxj1p,
  ID__toString_impl_y5caka_2 as ID__toString_impl_y5caka917l9wj8qah0,
  _ID___init__impl__k1lb7e_2 as _ID___init__impl__k1lb7e34qbnsrrpttnl,
  ID__hashCode_impl_f4lulz_3 as ID__hashCode_impl_f4lulz1g9m782w6adsw,
  ID__toString_impl_y5caka_3 as ID__toString_impl_y5caka2gmrcvcxhykhn,
  _ID___init__impl__k1lb7e as _ID___init__impl__k1lb7e213aw7xpq3qqc,
  ID__hashCode_impl_f4lulz_0 as ID__hashCode_impl_f4lulzrhf9x0v3ec95,
  _ID___get_raw__impl__92g6u5 as _ID___get_raw__impl__92g6u538uvogo1uv277,
  ID__toString_impl_y5caka_0 as ID__toString_impl_y5caka2oopvpysxo85x,
  _ID___init__impl__k1lb7e_3 as _ID___init__impl__k1lb7eetc5oa5dx2ra,
  ID__hashCode_impl_f4lulz_4 as ID__hashCode_impl_f4lulzhgc2u8u1q7v1,
  _ID___get_raw__impl__92g6u5_3 as _ID___get_raw__impl__92g6u53v684soiyq5c7,
  ID__toString_impl_y5caka_4 as ID__toString_impl_y5caka3samsckji65q8,
  ID__hashCode_impl_f4lulz_1 as ID__hashCode_impl_f4lulzwl94qweqdore,
  ID__toString_impl_y5caka_1 as ID__toString_impl_y5cakawnw120meic4d,
  CareLocationType_Center_getInstance as CareLocationType_Center_getInstance2f47v0wni4mas,
  EndReason_Other_getInstance as EndReason_Other_getInstancevgz3kb2sy6a4,
  ClosureReason_Emergency_getInstance as ClosureReason_Emergency_getInstance2e06kp9fjoz8u,
  ClosureReason_Flexible_getInstance as ClosureReason_Flexible_getInstance1hg43z0nox243,
  ClosureReason_Holiday_getInstance as ClosureReason_Holiday_getInstance1gv01vuec049b,
  ClosureReason_ProfessionalDevelopment_getInstance as ClosureReason_ProfessionalDevelopment_getInstancecpxpkronpmjz,
  ClosureReason_Unapproved_getInstance as ClosureReason_Unapproved_getInstance8leekbk2k7d1,
  Companion_instance_5 as Companion_instance11cvr3tzm4vi0,
  Companion_getInstance_21 as Companion_getInstance3624xnlg0493t,
  $serializer_getInstance_23 as $serializer_getInstance1dhvc4iof5db1,
  Companion_instance_17 as Companion_instancelcp2fs9k43iy,
  Companion_getInstance_31 as Companion_getInstance5c3fz7snx10k,
  Companion_instance_27 as Companion_instance1mnwh6xdpvhnr,
  Companion_getInstance_9 as Companion_getInstance1zy63bfjbn01p,
  $serializer_getInstance_15 as $serializer_getInstance1t4tj96m79rxb,
  Companion_instance_8 as Companion_instance3i4ej7wheox62,
  $serializer_getInstance_14 as $serializer_getInstance21thv1dv9fwx4,
  Companion_instance_7 as Companion_instanceijzyzhvr52hy,
  $serializer_getInstance_30 as $serializer_getInstance1xzjfnlwwk6fk,
  Companion_getInstance_27 as Companion_getInstance8cw09c4jvk3w,
  Companion_instance_23 as Companion_instance11icbntvxyz47,
  Companion_getInstance_29 as Companion_getInstance29yv2m82qhueb,
  Companion_instance_25 as Companion_instance8lbogr8agtsk,
  Companion_getInstance_17 as Companion_getInstance3n8qsn7k1orly,
  $serializer_getInstance_16 as $serializer_getInstance27t66pok72ar9,
  Companion_instance_9 as Companion_instance2y15a46qisr4b,
  Companion_instance_13 as Companion_instance3qb7v2pipun4h,
  Companion_instance_12 as Companion_instance3147idamxrkdi,
  Companion_instance_11 as Companion_instance12ap9399n2dhe,
  Companion_getInstance_32 as Companion_getInstance1atejy3oe81if,
  Companion_instance_2 as Companion_instance2mni8afnohjti,
  $serializer_getInstance_10 as $serializer_getInstance2m8ynx42p4oox,
  Companion_instance_1 as Companion_instance1cosffgar2men,
  $serializer_getInstance_22 as $serializer_getInstance1qlvq11on0v1u,
  Companion_getInstance_19 as Companion_getInstance2jaanzr07h9qp,
  $serializer_getInstance_21 as $serializer_getInstance1a39stva24llm,
  Companion_instance_15 as Companion_instance3zv09yetnwap,
  Companion_instance_22 as Companion_instanceh1a9dxwm5f9z,
  Companion_instance_21 as Companion_instance1ml9kof67ycp,
  Companion_instance_4 as Companion_instanceu8ez89pi8m0d,
  $serializer_getInstance_12 as $serializer_getInstance2jfn7wtddihen,
  Companion_instance_3 as Companion_instance2s5c8hzy4nzse,
  Companion_getInstance_35 as Companion_getInstance1wc081wkfo40w,
  Companion_instance_20 as Companion_instance1ujmr6an7etn7,
  Companion_getInstance_36 as Companion_getInstance2kycdbli06tg,
  Companion_instance_31 as Companion_instance31zndpf9pf1oi,
  Companion_instance_30 as Companion_instance10xobi09i40c6,
  Companion_getInstance_22 as Companion_getInstance2jmr19i6t9ie,
  get_entries_0 as get_entries3frsl8u2zqes2,
  values as values1pffia4rorsp7,
  ID_5 as ID1z61wlmtvxrjn,
  ID_9 as ID2snwv1w0j940u,
  CareLocationClosure as CareLocationClosure1da03s5ze3kft,
  get_entries_1 as get_entries3htl3g20ei9sb,
  CareLocation as CareLocation1v3u5wduz023s,
  ID_2 as ID1m87d1hextx54,
  CareProvider as CareProvider2qcawrqluyllr,
  ID_7 as ID2llykdzmszlol,
  ID_8 as ID3dyn3t5exl4nz,
  ChildAttendance as ChildAttendance80k6ssgtlom9,
  get_entries_2 as get_entries3kltg6n17y9pp,
  ID_3 as IDknm0szoty74n,
  Day as Day3noovgzg10lns,
  Schedule as Scheduleponvvaltzkys,
  ChildPlacement as ChildPlacement1fdgqwhgo48yv,
  Child as Child1dmbiwhmddqyq,
  get_entries_3 as get_entriesor5jvw043r71,
  ID_0 as IDqqik72jjbpsn,
  Employer as Employer27b20p5x27kte,
  ID_4 as IDjecfjjw6mot9,
  ID_6 as ID39tz9k5ges9xc,
  FamilyEmployerAuthorization as FamilyEmployerAuthorizationz43b3id5q687,
  Family as Family2k7vz7ddyergb,
  ID_1 as ID1lyj7m2ox8cp5,
  Grant as Grant2zfdfpt9q1mly,
  get_entries_4 as get_entries3tl980hg1b2bm,
  IncomeRange as IncomeRangeprzolg293f44,
  get_entries_5 as get_entries2mjjs5oycal4x,
  ID_10 as ID14pksykyak8vt,
  LocationAttendancePeriod as LocationAttendancePeriod3bx3r7kkwecs9,
  Parent as Parent27xjh1mdkxxuk,
};
//endregion

//# sourceMappingURL=domain.mjs.map
